import type { TranslationDataObj } from './type';

/* eslint-disable max-lines */
export const data: TranslationDataObj = {
  'app.invite': {
    title: {
      en: 'You have been invited to join {{ orgName }}',
      fr: 'Vous avez été invité à rejoindre {{ orgName }}',
    },
    joinAndCollaborate: {
      en: 'Join and collaborate',
      fr: 'Rejoindre et collaborer',
    },
  },
  'app.demo': {
    title: {
      en: 'Get Started with Blym',
      fr: 'Commencer avec Blym',
    },
    description: {
      en: 'Book a Blym Enterprise Demo to get expert answers.',
      fr: 'Réservez une démonstration Blym pour obtenir des réponses expert.',
    },
    companyUrl: {
      en: 'Company URL',
      fr: 'URL de la société',
    },
    chooseDateAndTime: {
      en: 'Choose date and time',
      fr: "Choisir la date et l'heure",
    },
  },
  'app.modal-org-invite': {
    multipleInvites: {
      en: 'You have been invited to {{count}} organizations',
      fr: '{{count}} organisations vous ont invité',
    },
    singleInvite: {
      en: 'You have been invited to join {{ orgName }}',
      fr: 'Vous avez été invité à rejoindre {{ orgName }}',
    },
    joinAndCollaborate: {
      en: 'Join and collaborate',
      fr: 'Rejoindre et collaborer',
    },
  },
  'app.onboarding': {
    howDidYouHear: {
      en: 'How did you hear about Blym?',
      fr: 'Comment avez-vous connu Blym ?',
    },
    originDescription: {
      en: 'Pick the one that best describes your experience',
      fr: 'Choisissez celle qui décrit le mieux votre expérience',
    },
    originRequired: {
      en: 'Please select how you heard about us',
      fr: 'Veuillez sélectionner comment vous avez connu Blym',
    },
    originOtherRequired: {
      en: 'Please specify how you heard about us',
      fr: 'Veuillez préciser comment vous avez connu Blym',
    },
    originOtherPlaceholder: {
      en: 'please specify',
      fr: 'veuillez préciser',
    },
    originGoogleSearch: {
      en: 'Google Search',
      fr: 'Recherche Google',
    },
    originLinkedin: {
      en: 'LinkedIn',
      fr: 'LinkedIn',
    },
    originChatgptAi: {
      en: 'ChatGPT (or other AI)',
      fr: 'ChatGPT (ou autre IA)',
    },
    originEvents: {
      en: 'Events',
      fr: 'Événements',
    },
    originWordOfMouth: {
      en: 'Word of mouth',
      fr: 'Bouche à oreille',
    },
    originFacebook: {
      en: 'Instagram or Facebook',
      fr: 'Instagram ou Facebook',
    },
    originYoutube: {
      en: 'Youtube',
      fr: 'Youtube',
    },
    originOther: {
      en: 'Other',
      fr: 'Autre',
    },
    setupYourBrand: {
      en: 'Set up your brand',
      fr: 'Configurez votre marque',
    },
    setupYourBrandDescription: {
      en: 'Add your website and choose where you want to rank',
      fr: 'Ajoutez votre site web et choisissez où vous souhaitez vous positionner',
    },
    homepage: {
      en: 'Homepage link',
      fr: "Lien de la page d'accueil",
    },
    aboutUs: {
      en: 'About us',
      fr: 'À propos de nous',
    },
    blogsPosts: {
      en: 'Content {{count}}',
      fr: 'Contenu {{count}}',
    },
    optional: {
      en: '(optional)',
      fr: '(optionnel)',
    },
    addAnotherBlogPostUrl: {
      en: 'Add another content URL',
      fr: 'Ajouter un autre lien de contenu',
    },
    builtBy: {
      en: 'Built by',
      fr: 'Créé par',
    },
    usedBy: {
      en: 'used by {{count}}+ companies in {{countryNumber}} countries',
      fr: 'utilisé par {{count}}+ entreprises dans {{countryNumber}} pays',
    },
    defineYourTargetingPreferences: {
      en: 'Define your targeting preferences',
      fr: 'Définissez vos préférences de ciblage',
    },
    targetDescription: {
      en: 'Select your default country and language for SERP analysis. You can customize them anytime.',
      fr: "Sélectionnez votre pays et votre langue par défaut pour l'analyse de la SERP. Vous pouvez les personnaliser à tout moment.",
    },
    next: {
      en: 'Next',
      fr: 'Suivant',
    },
    finish: {
      en: 'Finish',
      fr: 'Terminer',
    },
    finishAndContinue: {
      en: 'Finish and continue',
      fr: 'Terminer et continuer',
    },
    back: {
      en: 'Back',
      fr: 'Retour',
    },
    skipForNow: {
      en: 'Skip for now',
      fr: 'Passer pour le moment',
    },
    loading1Title: {
      en: 'Finishing setting up your brand details...',
      fr: 'Finalisation de la configuration de votre marque...',
    },
    loadingDescription: {
      en: 'This may take up to <strong>less than a minute</strong>',
      fr: "Cela devrait prendre <strong>moins d'une minute</strong>",
    },
    card1Title: {
      en: 'Blym captures <span class="text-branding-accent">your true tone of voice</span>',
      fr: "Blym s'imprègne du <span class='text-branding-accent'>ton de votre marque</span>",
    },
    card2Title: {
      en: 'Blym optimizes your SEO score <span class="text-branding-accent">before you publish</span>',
      fr: 'Blym optimise votre score SEO <span class="text-branding-accent">avant publication</span>',
    },
    card3Title: {
      en: 'Use SEO Insights™ to <span class="text-branding-accent">spy on top Google rankings</span>',
      fr: 'Utilisez SEO Insights™ pour <span class="text-branding-accent"> analyser les résultats Google</span>',
    },
    card4Title: {
      en: 'Ask Broono, our AI assistant, <span class="text-branding-accent">to edit, fix, or rewrite anything</span>',
      fr: "Demandez à Broono, notre assistant IA, <span class='text-branding-accent'>d'adapter ou de réécrire des paragraphes</span>",
    },
    loading2Title: {
      en: 'Setting up your personas...',
      fr: 'Configuration de vos personas...',
    },
    loading3Title: {
      en: 'Extracting voice examples from your website...',
      fr: 'Extraction de contenus depuis votre site...',
    },
    loading4Title: {
      en: 'Setting up your writing style...',
      fr: "Configuration de votre style d'écriture...",
    },
    titleModalGenerationError: {
      en: 'Something went wrong',
      fr: "Une erreur s'est produite",
    },
    descriptionModalGenerationError: {
      en: 'There was a problem while generating your brand context. You can try again or return to the previous step to review your URLs.',
      fr: "Une erreur s'est produite lors de la génération de votre Brand Context. Vous pouvez réessayer ou retourner à l'étape précédente pour vérifier vos URLs.",
    },
  },
  'app.sidebar': {
    content: {
      en: 'Content',
      fr: 'Contenu',
    },
    generate: {
      en: 'Generate',
      fr: 'Générer',
    },
    brandContext: {
      en: 'Brand context',
      fr: 'Brand context',
    },
    keywords: {
      en: 'Keywords',
      fr: 'Termes',
    },
    getHelp: {
      en: 'Get help',
      fr: "Obtenir de l'aide",
    },
    settings: {
      en: 'Settings',
      fr: 'Paramètres',
    },
    accountSettings: {
      en: 'Account settings',
      fr: 'Paramètres du compte',
    },
    users: {
      en: 'Users',
      fr: 'Utilisateurs',
    },
    organizations: {
      en: 'Organizations',
      fr: 'Organisations',
    },
    owned: {
      en: 'Owned',
      fr: 'Propriétaire',
    },
    brands: {
      en: 'Brands',
      fr: 'Marques',
    },
    addBrand: {
      en: 'Add brand',
      fr: 'Ajouter une marque',
    },
    oneCredit: {
      en: '{{ creditsCount }} credit',
      fr: '{{ creditsCount }} crédit',
    },
    multipleCredits: {
      en: '{{ creditsCount }} credits',
      fr: '{{ creditsCount }} crédits',
    },
    upgrade: {
      en: 'Upgrade',
      fr: 'Upgrade',
    },
    subscribeToAPlan: {
      en: 'Subscribe to a plan',
      fr: 'Souscrire à un plan',
    },
    blogPosts: {
      en: 'Content',
      fr: 'Contenu',
    },
    collections: {
      en: 'Collections',
      fr: 'Collections',
    },
    products: {
      en: 'Products',
      fr: 'Produits',
    },
    configuration: {
      en: 'Configuration',
      fr: 'Configuration',
    },
    comingSoon: {
      en: 'Coming soon',
      fr: 'À venir',
    },
    brandVoice: {
      en: 'Brand context',
      fr: 'Brand context',
    },

    addCredits: {
      en: 'Add credits',
      fr: 'Ajouter des crédits',
    },
    creditUsage: {
      en: 'Credit usage',
      fr: 'Utilisation des crédits',
    },
    analyse: {
      en: 'Analyze',
      fr: 'Analyser',
    },
    seoStrategy: {
      en: 'SEO strategy',
      fr: 'Audit SEO',
    },
  },
  'app.index': {
    creationDate: {
      en: 'Creation date',
      fr: 'Date de création',
    },
    updateDate: {
      en: 'Update date',
      fr: 'Date de mise à jour',
    },
    alphabeticalAZ: {
      en: 'A-Z',
      fr: 'A-Z',
    },
    alphabeticalZA: {
      en: 'Z-A',
      fr: 'Z-A',
    },
    title: {
      en: 'Content',
      fr: 'Contenu',
    },
    newContent: {
      en: 'New content',
      fr: 'Nouveau contenu',
    },
    sortBy: {
      en: 'Sort by',
      fr: 'Trier par',
    },
    createdBy: {
      en: 'Created by',
      fr: 'Créé par',
    },
    searchPlaceholder: {
      en: 'Search content',
      fr: 'Rechercher des contenus',
    },
    noResultsFound: {
      en: 'No results were found,',
      fr: 'Aucun résultat trouvé,',
    },
    clearFilters: {
      en: 'Clear filters',
      fr: 'Effacer les filtres',
    },
    loading: {
      en: 'Loading...',
      fr: 'Chargement...',
    },
    noContent: {
      en: 'Your content will appear here',
      fr: 'Votre contenu apparaîtra ici',
    },
    startCreating: {
      en: 'Start creating your first content',
      fr: 'Commencer à créer votre premier contenu',
    },
    description: {
      en: 'Generate content that ranks',
      fr: 'Générez du contenu qui réussit',
    },
    descriptionRewriteContent: {
      en: 'Rewrite and improve your existing articles with AI-powered optimization or create new SEO-optimized content',
      fr: "Réécrivez et améliorez vos articles existants avec l'optimisation IA ou créez de nouveaux contenus optimisés pour le SEO",
    },
    heroCalloutWatch: {
      en: 'Watch how blog creation works',
      fr: 'Regardez comment fonctionne la création de contenu',
    },
    useFreeCredit: {
      en: 'Use your free credit to generate content that ranks.',
      fr: 'Utilisez votre crédit gratuit pour générer un contenu.',
    },
    useYourCredits: {
      en: 'Use your credits to generate content that ranks.',
      fr: 'Utilisez vos crédits pour générer un contenu.',
    },
    createBlogPost: {
      en: 'Create content',
      fr: 'Créer un contenu',
    },
    rewriteContent: {
      en: 'Refresh content',
      fr: 'Réécrire un contenu',
    },
    createWithAI: {
      en: 'Create with IA',
      fr: 'Créer avec IA',
    },
    getStarted: {
      en: 'Start creating your first content',
      fr: 'Commencer avec votre premier contenu',
    },
    firstTimeCreating: {
      en: 'Use your free credit to generate content that ranks.',
      fr: 'Utilisez votre crédit gratuit pour générer du contenu qui réussit.',
    },
    createOne: {
      en: 'Create one',
      fr: 'En créer un',
    },
    fromScratch: {
      en: 'From scratch',
      fr: 'De zéro',
    },
    moreActions: {
      en: 'More actions',
      fr: "Plus d'actions",
    },
    errorAnalyzingSERP: {
      en: 'Error analyzing your SERP',
      fr: `Erreur lors de l'analyse de votre SERP`,
    },
    tryAgain: {
      en: 'Try again',
      fr: 'Relancer',
    },
    anErrorOccurred: {
      en: `An error occurred, we didn't charge you any credits.`,
      fr: `Une erreur s'est produite, nous ne vous avons pas facturé de crédits.`,
    },
    doYouWantToTryAgain: {
      en: 'Do you want to try again?',
      fr: 'Voulez-vous réessayer ?',
    },
    deleteContent: {
      en: 'Delete content',
      fr: 'Supprimer le contenu',
    },
    deleteContentConfirmation: {
      en: 'Are you sure you want to delete your content?',
      fr: 'Êtes-vous sûr de vouloir supprimer votre contenu?',
    },
    dontShowThisAgain: {
      en: `Don't show this again`,
      fr: 'Ne plus afficher',
    },
    emptyContent: {
      en: 'Your content will appear here',
      fr: 'Votre contenu apparaîtra ici,',
    },
    errorCreateContent: {
      en: 'An error occurred.',
      fr: `Une erreur s'est produite.`,
    },
    errorCreateContentDescription: {
      en: `Please try again later or contact support.`,
      fr: 'Veuillez réessayer plus tard ou contacter le support.',
    },
    trialEndedSuccess: {
      en: 'Your trial has ended. You can now generate content.',
      fr: "Votre période d'essai est terminée. Vous pouvez maintenant générer du contenu.",
    },
    tipFirstTime: {
      en: 'Tip: You can keep creating new posts while others are still in progress.',
      fr: "Conseil: Vous pouvez continuer à créer des articles de blog pendant que d'autres sont en cours de génération.",
    },
  },
  'app.-section-content-card': {
    retry: {
      en: 'Retry',
      fr: 'Réessayer',
    },
    titlesGenerating: {
      en: 'Generating titles',
      fr: 'Génération de titres',
    },
    extraInformationGenerating: {
      en: 'Content brief ready',
      fr: 'Brief de contenu prêt',
    },
    titlesGenerated: {
      en: 'Titles ready',
      fr: 'Titres prêts',
    },
    outlinesGenerating: {
      en: 'Generating outlines',
      fr: 'Génération de plans',
    },
    outlinesGenerated: {
      en: 'Outlines ready',
      fr: 'Plans prêt',
    },
    contentGenerating: {
      en: 'Generating content',
      fr: 'Génération de contenu',
    },
    statusReady: {
      en: 'Ready to write',
      fr: 'Prêt à écrire',
    },
    googleSerp: {
      en: 'Google SERP',
      fr: 'SERP Google',
    },
    creatingSerp: {
      en: 'Creating SERP insights',
      fr: 'Création de la SERP insights',
    },
    creatingGEO: {
      en: 'Creating GEO insights',
      fr: 'Création du GEO',
    },
    statusGenerating: {
      en: 'Analyzing Google SERP',
      fr: 'Analyse de la SERP Google',
    },
    statusRefreshing: {
      en: 'Refreshing content',
      fr: 'Régénération du contenu',
    },
    statusRefreshingError: {
      en: 'Error refreshing content',
      fr: 'Erreur lors de la régénération du contenu',
    },
    statusAnalysisError: {
      en: 'Error Analyzing SERP',
      fr: `Erreur d'analyse SERP`,
    },
    delete: {
      en: 'Delete',
      fr: 'Supprimer',
    },
    editContent: {
      en: 'Edit content',
      fr: 'Modifier le contenu',
    },
    edit: {
      en: 'Edit',
      fr: 'Modifier',
    },
    words: {
      en: '{{wordsCount}} words',
      fr: '{{wordsCount}} mots',
    },
    author: {
      en: 'Created by',
      fr: 'Créé par',
    },
    titlesGenerationError: {
      en: 'Titles generation error',
      fr: 'Erreur de génération de titres',
    },
    outlinesGenerationError: {
      en: 'Outlines generation error',
      fr: 'Erreur de génération de plans',
    },
    contentGenerationError: {
      en: 'Content generation error',
      fr: 'Erreur de génération de contenu',
    },
    createdBy: {
      en: 'Created by {{ author }}',
      fr: 'Créé par {{ author }}',
    },
    generatingContent: {
      en: 'Our AI is generating content...',
      fr: 'Notre IA génère du contenu...',
    },
    scoreSeo: {
      en: 'SEO score',
      fr: 'Score SEO',
    },
    statusOk: {
      en: 'Content ready',
      fr: 'Contenu prêt',
    },
    loadingEstimate: {
      en: 'Estimated time: 2 - 3 minutes',
      fr: 'Temps estimé: 2 - 3 minutes',
    },
    loadingEstimateOneClick: {
      en: 'Estimated time: 7 - 8 minutes',
      fr: 'Temps estimé: 7 - 8 minutes',
    },
    claude: {
      en: 'Claude',
      fr: 'Claude',
    },
    perplexity: {
      en: 'Perplexity',
      fr: 'Perplexity',
    },
    openai: {
      en: 'ChatGPT',
      fr: 'ChatGPT',
    },
    gemini: {
      en: 'Gemini',
      fr: 'Gemini',
    },
    publicationStatusDraft: {
      en: 'Draft',
      fr: 'Brouillon',
    },
    publicationStatusToReview: {
      en: 'To review',
      fr: 'À valider',
    },
    publicationStatusApproved: {
      en: 'Approved',
      fr: 'Approuvé',
    },
    publicationStatusPublished: {
      en: 'Published',
      fr: 'Publié',
    },
    publicationStatus: {
      en: 'Status',
      fr: 'Statut',
    },
    publishedModalTitle: {
      en: 'Confirm publication',
      fr: 'Confirmer la publication',
    },
    publishedModalDescription: {
      en: 'Confirm where and when this article was published',
      fr: "Confirmez l'URL et la date de publication pour suivre votre contenu publié.",
    },
    publishedModalUrlLabel: {
      en: 'Publication URL',
      fr: 'URL de publication',
    },
    publishedModalUrlPlaceholder: {
      en: 'https://example.com/my-article',
      fr: 'https://exemple.com/mon-article',
    },
    publishedModalDateLabel: {
      en: 'Publication date',
      fr: 'Date de publication',
    },
    publishedModalConfirm: {
      en: 'Mark as published',
      fr: 'Marquer comme publié',
    },
    publishedModalCancel: {
      en: 'Cancel',
      fr: 'Annuler',
    },
  },
  'app.blogs.-section-modal-generation': {
    seoKeyword: {
      en: 'Primary SEO keyword',
      fr: 'Mot-clé SEO primaire',
    },
    contentTopicHelpText: {
      en: 'Describe what your content will cover. We can suggest your SEO keyword based on this.',
      fr: 'Décrivez votre sujet, nous suggérerons les mots clés SEO associés.',
    },
    keywordToRankHelpText: {
      en: 'What people would type in Google to find your content.',
      fr: 'Ce que les gens taperaient dans Google pour trouver votre contenu.',
    },
    tooltipTopicTitle: {
      en: 'Describe what your content will cover.',
      fr: 'Décrivez ce que votre contenu couvrira.',
    },
    tooltipTopicDescription: {
      en: 'We can suggest your SEO keyword based on this.',
      fr: 'Nous pouvons suggérer votre mot-clé SEO en fonction de cela.',
    },
    tooltipKeywordTitle: {
      en: 'The keyword people would type in Google to find your content.',
      fr: 'Le mot-clé que les gens taperaient dans Google pour trouver votre contenu.',
    },
    tooltipKeywordDescription: {
      en: 'Add your own or generate one.',
      fr: 'Ajoutez le vôtre ou générez-en un.',
    },
    contentTopic: {
      en: 'Content topic',
      fr: 'Sujet de la page',
    },
    prompt: {
      en: 'Targeted Prompt',
      fr: 'Prompt cible',
    },
    generate: {
      en: 'Generate ({{ creditCost }} credit)',
      fr: 'Générer ({{ creditCost }} crédit)',
    },
    continue: {
      en: 'Continue ({{ creditCost }} credit)',
      fr: 'Continuer ({{ creditCost }} crédit)',
    },
    keywordToRank: {
      en: 'Keyword to rank',
      fr: 'Mot-clé à ranker',
    },
    title: {
      en: 'New content',
      fr: 'Nouveau contenu',
    },
    topic: {
      en: 'Write a content about...',
      fr: 'Écrire un contenu sur...',
    },
    optional: {
      en: '(optional)',
      fr: '(optionnel)',
    },
    searchQuery: {
      en: 'Search query or keyword',
      fr: 'Mot-clé ou requête de recherche',
    },
    searchQueryHelpText: {
      en: 'Enter the query or keyword you want to rank for in Google.',
      fr: 'Entrez la requête ou le mot-clé que vous souhaitez ranker dans Google.',
    },
    searchQueryPlaceholder: {
      en: 'e.g Supplements magnesium',
      fr: 'e.g Compléments alimentaires magnésium',
    },
    topicPlaceholder: {
      en: `e.g., "A beginner's guide to starting an online store"`,
      fr: `e.g., "Un guide pour débutants sur le lancement d'une boutique en ligne"`,
    },
    keywordRankOnGoogle: {
      en: 'e.g., “best SaaS marketing tool”',
      fr: 'ex. "meilleurs outils marketing SaaS"',
    },
    promptRankOnGoogle: {
      en: 'e.g., “What is the best marketing tool for a SaaS?”',
      fr: 'ex. "Quel est le meilleur outil marketing pour un SaaS ?"',
    },
    promptHelpText: {
      en: 'What people would ask in an AI assistant to find your content. <0>Learn more</0>',
      fr: 'Ce que vos clients taperaient dans un assistant IA pour trouver votre contenu. <0>En savoir plus</0>',
    },
    searchQueryDescription: {
      en: 'Enter the query or keyword you want to rank for in Google.',
      fr: 'Entrez la requête ou le mot-clé que vous souhaitez ranker dans Google.',
    },
    searchLocal: {
      en: 'Search locally',
      fr: 'Rechercher localement',
    },
    searchGlobal: {
      en: 'Select the country and language where you want your content to rank.',
      fr: 'Sélectionnez le pays et la langue où vous souhaitez que votre contenu soit classé.',
    },
    searchCountryLanguageDescription: {
      en: 'Select the country and language where you want your content to rank.',
      fr: 'Sélectionnez le pays et la langue où vous souhaitez que votre contenu soit classé.',
    },
    create: {
      en: 'Create new content',
      fr: 'Créer un nouveau contenu',
    },
    analyze: {
      en: 'Analyze',
      fr: 'Analyser',
    },
    createNewContentWithCredit: {
      en: 'Create new content',
      fr: 'Créer un nouveau contenu',
    },
    newContent: {
      en: 'New content',
      fr: 'Nouveau contenu',
    },
    aiInProgress: {
      en: 'Our AI is analyzing search results to generate recommendations.',
      fr: 'IA analyse les résultats de recherche pour générer des recommandations.',
    },
    aiProgressSubtitle: {
      en: 'This might take a few minutes. You can close this window.',
      fr: 'Cela peut prendre quelques minutes. Vous pouvez fermer cette fenêtre.',
    },
    errorKeyword: {
      en: 'Please enter a keyword',
      fr: 'Veuillez entrer un mot-clé',
    },
    generationType: {
      en: 'Generation mode',
      fr: 'Mode de génération',
    },
    oneClickGenerationTitle: {
      en: 'One-click generation',
      fr: 'Génération en un clic',
    },
    oneClickGenerationSubtitle: {
      en: 'Instantly create a full content with your brand context and SERP insights.',
      fr: 'Générez un contenu complet avec votre contexte de marque et les insights de la SERP en un clic.',
    },
    funnelGenerationTitle: {
      en: '3 step workflow',
      fr: 'Workflow en 3 étapes',
    },
    funnelGenerationSubtitle: {
      en: 'More tailored content with control over the content brief, title and outline.',
      fr: "Articles plus adaptés avec contrôle sur le titre, la structure et l'expertise.",
    },
    funnelDisabledTooltip: {
      en: 'Only available in desktop',
      fr: 'Disponible uniquement sur desktop',
    },
    generateKeyword: {
      en: 'Generate keyword',
      fr: 'Générer un mot-clé',
    },
    generatePrompt: {
      en: 'Generate prompt',
      fr: 'Générer un prompt',
    },
    generating: {
      en: 'Generating...',
      fr: 'Génération...',
    },
    generated: {
      en: 'Regenerate',
      fr: 'Régénérer',
    },
    error: {
      en: 'Retry generate',
      fr: 'Réessayer la génération',
    },
    learnMore: {
      en: 'Learn more',
      fr: 'En savoir plus',
    },
  },
  'app.blogs.-modal-rewrite': {
    back: {
      en: 'Back',
      fr: 'Retour',
    },
    continue: {
      en: 'Continue',
      fr: 'Continuer',
    },
    cancel: {
      en: 'Cancel',
      fr: 'Annuler',
    },
    rewriteContent: {
      en: 'Refresh content ({{ creditCost }} credits) ',
      fr: 'Réécrire le contenu ({{ creditCost }} crédits) ',
    },
    modalTitle: {
      en: 'Refresh content',
      fr: 'Réécrire le contenu',
    },
    seeHowItWorks: {
      en: 'See How It Works',
      fr: 'Voir comment ça marche',
    },
    contentSource: {
      en: 'Content source',
      fr: 'Source du contenu',
    },
    keyword: {
      en: 'Keyword',
      fr: 'Mot-clé',
    },
    optimization: {
      en: 'Optimization',
      fr: 'Optimisation',
    },
    contentTitle: {
      en: 'Title',
      fr: 'Titre',
    },
    chooseProviderLabel: {
      en: 'Choose how to provide your content',
      fr: 'Choisir comment fournir votre contenu',
    },
    titlePlaceholder: {
      en: 'e.g How to start an ecommerce”',
      fr: 'ex. "Comment démarrer une boutique en ligne"',
    },
    urlLabel: {
      en: 'URL',
      fr: 'URL',
    },
    pasteLabel: {
      en: 'Paste content',
      fr: 'Coller le contenu',
    },
    urlDescription: {
      en: 'We’ll extract the content',
      fr: "Nous extrairons le contenu de l'URL",
    },
    pasteDescription: {
      en: 'Paste your content here',
      fr: 'Collez votre contenu ici',
    },
    urlContentLabel: {
      en: 'URL of the content',
      fr: 'URL du contenu',
    },
    contentLabel: {
      en: 'Your content',
      fr: 'Votre contenu',
    },
    pasteContentLabel: {
      en: 'Paste your content',
      fr: 'Collez votre contenu',
    },
    contentDescription: {
      en: 'Paste the full content of your article with formatting.',
      fr: 'Collez le contenu complet de votre article avec le formatage.',
    },
    lightRefreshLabel: {
      en: 'Light refresh',
      fr: 'Régénération légère',
    },
    lightRefreshDescription: {
      en: "For content that's already ranking well",
      fr: 'Pour le contenu qui est déjà bien classé',
    },
    lightRefreshBullet1: {
      en: 'Update dates and statistics',
      fr: 'Mettre à jour les dates et statistiques',
    },
    lightRefreshBullet2: {
      en: 'Refresh outdated information',
      fr: 'Actualiser les informations obsolètes',
    },
    lightRefreshBullet3: {
      en: 'Small structural improvements',
      fr: 'Petites améliorations structurelles',
    },
    lightRefreshBullet4: {
      en: 'Signal freshness to Google/LLMs',
      fr: 'Signaler la fraîcheur à Google/LLMs',
    },
    majorRewriteBullet1: {
      en: 'Update dates and statistics',
      fr: 'Mettre à jour les dates et statistiques',
    },
    majorRewriteBullet2: {
      en: 'Refresh outdated information',
      fr: 'Actualiser les informations obsolètes',
    },
    majorRewriteBullet3: {
      en: 'Small structural improvements',
      fr: 'Petites améliorations structurelles',
    },
    majorRewriteBullet4: {
      en: 'Signal freshness to Google/LLMs',
      fr: 'Signaler la fraîcheur à Google/LLMs',
    },
    contentLengthLabel: {
      en: 'Content length',
      fr: 'Longueur du contenu',
    },
    contentLengthAuto: {
      en: 'Auto',
      fr: 'Auto',
    },
    contentLengthSame: {
      en: 'Same',
      fr: 'Identique',
    },
    contentLengthCustom: {
      en: 'Custom',
      fr: 'Personnalisé',
    },
    contentLengthAutoDescription: {
      en: 'Auto is based on competition and recommended by Blym',
      fr: 'Auto est basé sur la concurrence et recommandé par Blym',
    },
    specificInstructionsLabel: {
      en: 'Specific instructions',
      fr: 'Instructions spécifiques',
    },
    specificInstructionsOptional: {
      en: '(optional)',
      fr: '(optionnel)',
    },
    specificInstructionsPlaceholder: {
      en: 'e.g. Update my introduction, Reorder my 10 list...',
      fr: 'ex. Mettre à jour mon introduction, Réorganiser ma liste de 10...',
    },
    majorRewriteLabel: {
      en: 'Major rewrite',
      fr: 'Réécriture majeure',
    },
    majorRewriteDescription: {
      en: 'For underperforming content',
      fr: 'Pour le contenu qui ne performe pas bien',
    },
    comingSoon: {
      en: 'Coming Soon',
      fr: 'Bientôt disponible',
    },
    errorRefreshContent: {
      en: 'Error refreshing content',
      fr: 'Erreur lors de la régénération du contenu',
    },
  },
  'app.blogs.-keyword-suggestions-dropdown': {
    keywordSuggestions: {
      en: 'Keyword suggestions',
      fr: 'Suggestions de mots-clés',
    },
    na: {
      en: 'N/A',
      fr: 'N/A',
    },
    easy: {
      en: 'Easy',
      fr: 'Facile',
    },
    medium: {
      en: 'Medium',
      fr: 'Moyen',
    },
    difficult: {
      en: 'Difficult',
      fr: 'Difficile',
    },
  },
  'app.blogs.-brand-not-filled-modal': {
    title: {
      en: 'Your Brand Context isn’t filled in',
      fr: 'Votre Brand Context n’est pas rempli',
    },
    description: {
      en: 'Fill in your Brand Context to have generated content that reflects your brand’s tone and style',
      fr: 'Remplissez votre Brand Context pour avoir un contenu généré qui reflète le ton et le style de votre marque',
    },
    createAnyway: {
      en: 'Create anyway',
      fr: 'Créer quand même',
    },
    addBrandContext: {
      en: 'Add Brand Context first',
      fr: 'Remplir le Brand Context',
    },
  },
  'app.content.$id': {
    undo: {
      en: 'Undo',
      fr: 'Annuler',
    },
    unsavedChanges: {
      en: 'You have unsaved changes. Are you sure you want to leave?',
      fr: 'Les modifications que vous avez apportées ne seront peut-être pas enregistrées.',
    },
    ratingToastTitle: {
      en: 'Thank you',
      fr: 'Merci',
    },
    ratingToastDescription: {
      en: 'Your feedback has been sent',
      fr: 'Vos commentaires ont été envoyés',
    },
  },
  'app.content.-editor.content-editor': {
    generalRatingTitle: {
      en: 'Your feedback shapes your future content',
      fr: 'Votre retour façonne vos prochains contenus',
    },
    youCanReuseYourPrompt: {
      en: 'You can reuse your prompt in the future',
      fr: `Vous pourrez réutiliser votre prompt à l'avenir`,
    },
    savePrompt: {
      en: 'Save prompt',
      fr: 'Enregistrer la requête',
    },
  },
  'app.content.-editor.blocked-editor-card': {
    subscribeToContinue: {
      en: 'Subscribe to continue reading <br /> and access all features.',
      fr: 'Abonnez-vous pour continuer à lire <br /> et accéder à toutes les fonctionnalités.',
    },
    powerYourCreativity: {
      en: 'Power your creativity with unlimited access.',
      fr: 'Boostez votre créativité avec un accès illimité.',
    },
    startXDayFreeTrial: {
      en: 'Start {{trialDays}}-day free trial',
      fr: "Commencer l'essai gratuit de {{trialDays}} jours",
    },
    cancelAtAnyTime: {
      en: 'Cancel at any time',
      fr: 'Annuler à tout moment',
    },
  },
  'app.content.-editor.modal-cancelled-sub': {
    title: {
      en: 'Your subscription has been cancelled',
      fr: 'Votre abonnement a été annulé',
    },
    description: {
      en: 'Reactivate your plan to regain access to your documents.',
      fr: 'Réactivez votre abonnement pour retrouver accès à vos documents.',
    },
    reactivateSubscription: {
      en: 'Reactivate subscription',
      fr: "Réactiver l'abonnement",
    },
  },
  'app.content.-editor.editor-pull-tab': {
    pullTabTitle: {
      en: 'Title and description',
      fr: 'Titre et description',
    },
    title: {
      en: 'Title',
      fr: 'Titre',
    },
    description: {
      en: 'Description',
      fr: 'Description',
    },
    metaInfo: {
      en: 'Meta information',
      fr: 'Meta informations',
    },
    metaTitle: {
      en: 'Meta title',
      fr: 'Titre SEO',
    },
    metaDescription: {
      en: 'Meta description',
      fr: 'Meta description',
    },
    metaTitlePlaceholder: {
      en: 'Enter a compelling title for your content (max {{limit}} characters)',
      fr: 'Saisissez un titre attrayant pour votre contenu (max {{limit}} caractères)',
    },
    metaDescriptionPlaceholder: {
      en: 'Summarize your content in one or two sentences (max {{limit}} characters)',
      fr: 'Résumez votre contenu en une ou deux phrases (max {{limit}} caractères)',
    },
    metaTitleFieldPlaceholder: {
      en: 'Write a clear, catchy title that makes people want to click.',
      fr: 'Saisissez un titre clair et attrayant qui donne envie de cliquer.',
    },
    metaDescriptionFieldPlaceholder: {
      en: 'Summarize your content in one or two compelling sentences that encourage clicks.',
      fr: 'Résumez votre contenu en une ou deux phrases percutantes qui incitent à la lecture.',
    },
    urlSlug: {
      en: 'URL slug',
      fr: 'Slug URL',
    },
    urlSlugFieldPlaceholder: {
      en: 'your-page-url-slug',
      fr: 'votre-slug-url',
    },
    aiEssential: {
      en: 'AI-essential',
      fr: 'IA-essentiel',
    },
    tooltipTitle: {
      en: 'Why This Matters for AI & GEO',
      fr: "Pourquoi c'est important pour l'IA & GEO",
    },
    metaDescriptionTooltip: {
      en: "The meta description helps AI systems (ChatGPT, Perplexity, Claude) determine if your page answers the user's prompt. AI models scan this to decide whether to cite your content as a relevant source.",
      fr: "La meta description aide les systèmes d'IA (ChatGPT, Perplexity, Claude) à déterminer si votre page répond à la requête de l'utilisateur. Les modèles d'IA analysent cela pour décider s'ils doivent citer votre contenu comme source pertinente.",
    },
    urlSlugTooltip: {
      en: "The URL slug is one of the first signals AI engines use to understand your content's relevance. A clear, descriptive slug that mirrors your prompt's intent dramatically improves your chances of being cited by AI systems.",
      fr: "Le slug URL est l'un des premiers signaux que les moteurs d'IA utilisent pour comprendre la pertinence de votre contenu. Un slug clair et descriptif qui reflète l'intention de votre requête améliore considérablement vos chances d'être cité par les systèmes d'IA.",
    },
  },
  'app.content.-editor.editor-sidebar': {
    score: {
      en: 'Score',
      fr: 'Score',
    },
    serp: {
      en: 'SERP',
      fr: 'SERP',
    },
    terms: {
      en: 'Terms',
      fr: 'Termes',
    },
    geo: {
      en: 'GEO',
      fr: 'GEO',
    },
  },
  'app.content.-editor.save-state-indicator': {
    savingChanges: {
      en: 'Saving changes...',
      fr: 'Enregistrement des modifications...',
    },
    savingChangesTooltip: {
      en: 'Your changes are being saved.',
      fr: "Vos modifications sont en cours d'enregistrement.",
    },
    savedChanges: {
      en: 'All changes saved',
      fr: 'Toutes les modifications ont été enregistrées',
    },
    errorSavingChanges: {
      en: 'Errors saving',
      fr: "Erreurs lors de l'enregistrement des modifications",
    },
    errorSavingChangesTooltip: {
      en: 'There where errors saving this file. Please try again or refresh.',
      fr: "Il y a eu des erreurs lors de l'enregistrement de ce fichier. Veuillez réessayer ou rafraîchir.",
    },
  },
  'app.content.-editor.editor-toolbar': {
    undo: {
      en: 'Undo',
      fr: 'Annuler',
    },
    redo: {
      en: 'Redo',
      fr: 'Rétablir',
    },
    bold: {
      en: 'Bold',
      fr: 'Gras',
    },
    italic: {
      en: 'Italic',
      fr: 'Italique',
    },
    underline: {
      en: 'Underline',
      fr: 'Souligné',
    },
    strikethrough: {
      en: 'Strikethrough',
      fr: 'Barré',
    },
    bulletList: {
      en: 'List',
      fr: 'Liste',
    },
    numberList: {
      en: 'Numbered list',
      fr: 'Liste numérotée',
    },
    link: {
      en: 'Link',
      fr: 'Lien',
    },
    image: {
      en: 'Image',
      fr: 'Image',
    },
    code: {
      en: 'Code',
      fr: 'Code',
    },
    horizontalRule: {
      en: 'Horizontal rule',
      fr: 'Ligne horizontale',
    },
    lastSaved: {
      en: 'Last saved',
      fr: 'Dernière sauvegarde',
    },
  },
  'app.content.-editor.terms-section': {
    intro: {
      en: 'This is a list of recommended terms to include in your content. The more terms highlighted in green, the higher your SEO score.',
      fr: 'Cette liste contient des termes recommandés à inclure dans votre contenu. Plus les termes sont en vert, plus votre score SEO sera élevé.',
    },
    failedToCopy: {
      en: 'Failed to copy',
      fr: 'Échec de la copie',
    },
    failedToCreateTerm: {
      en: 'Failed to create term',
      fr: 'Échec de la création du terme',
    },
    failedToAddBackTerm: {
      en: 'Failed to add back term',
      fr: `Échec de l'ajout du terme`,
    },
    failedToRemoveTerm: {
      en: 'Failed to remove term',
      fr: 'Échec de la suppression du terme',
    },
    movedToRemovedTerms: {
      en: 'Moved to removed terms',
      fr: 'Déplacé vers les termes supprimés',
    },
    movedToTermsList: {
      en: 'Moved to terms list',
      fr: 'Déplacé vers la liste des termes',
    },
  },
  'app.content.-editor.term-item': {
    // eslint-disable-next-line camelcase
    times_one: {
      en: 'time',
      fr: 'foi',
    },
    // eslint-disable-next-line camelcase
    times_other: {
      en: 'times',
      fr: 'fois',
    },
    itemTooltip: {
      en: 'Use {{min}}-{{max}} times. Currently used {{count}} $t(app.content.-editor.term-item.times, {"count": {{count}}}).',
      fr: 'Utiliser {{min}}-{{max}} fois. Actuellement utilisé {{count}} $t(app.content.-editor.term-item.times, {"count": {{count}}}).',
    },
    headingBadgeTooltip: {
      en: 'Use it in the heading.',
      fr: `Utilisez-le dans l'en- tête.`,
    },
  },
  'app.content.-editor.terms-control': {
    filters: {
      en: 'Filters',
      fr: 'Filtres',
    },
    unused: {
      en: 'Unused',
      fr: 'Non utilisé',
    },
    overused: {
      en: 'Overused',
      fr: 'Surutilisé',
    },
    passed: {
      en: 'Passed',
      fr: 'Validé',
    },
    needsImprovement: {
      en: 'Needs improvement',
      fr: 'À améliorer',
    },
    headings: {
      en: 'Headings',
      fr: 'Titres',
    },
    addATerm: {
      en: 'Add a term',
      fr: 'Ajouter un terme',
    },
    copyAllTerms: {
      en: 'Copy all terms',
      fr: 'Copier tous les termes',
    },
    removedTerms: {
      en: 'Removed terms',
      fr: 'Termes supprimés',
    },
    clearSearch: {
      en: 'Clear search',
      fr: 'Effacer la recherche',
    },
    search: {
      en: 'Search',
      fr: 'Rechercher',
    },
    sortBy: {
      en: 'Sort by',
      fr: 'Trier par',
    },
    sortByRelevance: {
      en: 'SEO Relevance',
      fr: 'Pertinence SEO',
    },
    sortAlphabetically: {
      en: 'Alphabetically',
      fr: 'Alphabétique',
    },
  },
  'app.content.-editor.terms-list': {
    noResults: {
      en: 'There are no results for this search.',
      fr: 'Aucun résultat pour cette recherche.',
    },
  },
  'app.content.-editor.seo-section': {
    intro: {
      en: 'The more tasks you finish the better score your content will have.',
      fr: 'Plus vous réaliserez de tâches, meilleur sera votre score.',
    },
    seoPoints: {
      en: '{{points}} pts',
      fr: '{{points}} pts',
    },
    progressTitleDescription: {
      en: 'Shows how far {{title}} has been done',
      fr: 'Montre à quel point {{title}} a été fait',
    },
    progressTitle: {
      en: '{{title}} progress',
      fr: '{{title}} progrès',
    },
    congrats: {
      en: 'Congrats!',
      fr: 'Félicitations !',
    },
    rangeIndicatorLabel: {
      en: 'SEO performance indicator',
      fr: 'Indicateur de performance SEO',
    },
    reachCompetitionLevel: {
      en: 'Your content has reached the competition level',
      fr: 'Votre contenu a atteint le niveau de concurrence',
    },
    rangeIndicatorDescription: {
      en: 'How well your SEO performs',
      fr: 'Comment votre SEO se comporte',
    },
    headings: {
      en: 'Headings',
      fr: 'Titres',
    },
    meta: {
      en: 'Meta information',
      fr: 'Meta informations',
    },
    links: {
      en: 'Links',
      fr: 'Liens',
    },
    content: {
      en: 'Content',
      fr: 'Contenu',
    },
    tasks: {
      en: 'Tasks',
      fr: 'Tâches',
    },
    taskHelp: {
      en: `Complete the tasks below to increase your SEO score and improve your content's ranking in Google.`,
      fr: 'Complétez les tâches ci-dessous pour augmenter votre score SEO et améliorer le classement de votre contenu dans Google.',
    },
  },
  'app.content.-editor.seo-progress-bar': {
    textProgressBarEmpty: {
      en: 'Add some content',
      fr: 'Ajouter du contenu pour voir votre score.',
    },
    textProgressBarBad: {
      en: 'Bad',
      fr: 'Mauvais',
    },
    textProgressBarNeedsImprovement: {
      en: 'Needs improvement',
      fr: 'À améliorer',
    },
    textProgressBarGood: {
      en: 'Good',
      fr: 'Bon',
    },
    textProgressBarPerfect: {
      en: 'Perfect!',
      fr: 'Parfait!',
    },
    tooltipProgressBarEmpty: {
      en: 'Add content to see your score.',
      fr: 'Ajouter du contenu pour voir votre score.',
    },
    tooltipProgressBarBad: {
      en: 'Your content needs major improvements, keep it up!',
      fr: 'Votre contenu nécessite des améliorations majeures, continuez!',
    },
    tooltipProgressBarNeedsImprovement: {
      en: 'You are almost there, your content need slight improvements.',
      fr: 'Vous y êtes presque, votre contenu nécessite des améliorations légères.',
    },
    tooltipProgressBarGood: {
      en: 'Good, but it could be perfect!',
      fr: 'Bon, mais il pourrait être parfait!',
    },
    tooltipProgressBarPerfect: {
      en: 'You made it, time to publish!',
      fr: "Vous l'avez fait, il est temps de publier!",
    },
    rangeIndicatorTooltip: {
      en: 'The Content Score ranges from 1 to 100, reflecting the quality and relevance of the content.',
      fr: 'Le score du contenu varie de 1 à 100, reflétant la qualité et la pertinence du contenu.',
    },
    avgScoreTooltip: {
      en: 'Avg Blym SEO score of top pages.',
      fr: 'Score moyen des concurrents SEO',
    },
    avgWordsCountTooltip: {
      en: 'Avg word count of competitors SEO.',
      fr: 'Nombre de mots moyen des concurrents SEO',
    },
    wordCount: {
      en: 'Word count: {{ wordsCount }}',
      fr: 'Nombre de mots: {{ wordsCount }}',
    },
    avgData: {
      en: 'Avg: {{ avgData }}',
      fr: 'Moy: {{ avgData }}',
    },
  },
  'app.content.-editor.editor-footer': {
    // eslint-disable-next-line camelcase
    words_one: {
      en: '{{count}} word',
      fr: '{{count}} mot',
    },
    // eslint-disable-next-line camelcase
    words_other: {
      en: '{{count}} words',
      fr: '{{count}} mots',
    },
    // eslint-disable-next-line camelcase
    characters_one: {
      en: '{{count}} character',
      fr: '{{count}} caractère',
    },
    // eslint-disable-next-line camelcase
    characters_other: {
      en: '{{count}} characters',
      fr: '{{count}} caractères',
    },
    // eslint-disable-next-line camelcase
    links_one: {
      en: '{{count}} link',
      fr: '{{count}} lien',
    },
    // eslint-disable-next-line camelcase
    links_other: {
      en: '{{count}} links',
      fr: '{{count}} liens',
    },
  },
  'app.content.-editor.competition-section': {
    scrappedFromGoogle: {
      en: 'Scrapped from Google',
      fr: 'Scrapé de Google',
    },
    intro: {
      en: 'Analysis based on current Google search results for your keyword.',
      fr: 'Analyse basée sur les résultats de recherche Google actuels pour votre mot-clé.',
    },
    showMore: {
      en: 'View all',
      fr: 'Afficher tout',
    },
    showLess: {
      en: 'View less',
      fr: 'Afficher moins',
    },
    rank: {
      en: 'Rank {{position}}',
      fr: 'Rang {{position}}',
    },
    visitLink: {
      en: 'Visit {{link}} (opens in new tab)',
      fr: 'Visiter {{link}} (ouvre dans un nouvel onglet)',
    },
    competitionTitle: {
      en: 'Competitors SEO',
      fr: 'Concurrents SEO',
    },
    searchResultInsight: {
      en: 'Search result insight',
      fr: 'Synthèse de la recherche',
    },
    competitionTooltip: {
      en: 'We analyzed the top results on Google for your keyword and extracted their outline. Use this data to improve yours.',
      fr: 'Nous avons analysé les meilleurs résultats sur Google pour votre mot-clé et extrait leur structure. Utilisez ces données pour améliorer la vôtre.',
    },
    competitionSummaries: {
      en: 'Competition summaries',
      fr: 'Résumés de concurrence',
    },
    userIntent: {
      en: 'User search intent',
      fr: 'Intention de recherche',
    },
    alsoAsked: {
      en: 'People also ask',
      fr: 'Questions fréquentes associées',
    },
    alsoAskedTooltipTitle: {
      en: 'People also ask',
      fr: 'Questions fréquentes sur Google',
    },
    alsoAskedTooltipDescription: {
      en: 'Common related questions from Google.',
      fr: 'Questions fréquentes sur Google',
    },
    userIntentDescription: {
      en: "Objective of the user's query",
      fr: "Objectif de la requête de l'utilisateur",
    },
    serpAnalysis: {
      en: 'SERP analysis',
      fr: 'Analyse SERP',
    },
    serpAnalysisTooltipTitle: {
      en: 'SERP (Search Engine Results Page)',
      fr: 'SERP (Page de résultats de moteur de recherche)',
    },
    serpAnalysisTooltipDescription: {
      en: 'SERP Analysis reviews the competitors SEO for a keyword to understand what Google prioritizes.',
      fr: `L'analyse SERP examine les concurrents SEO pour un mot-clé afin de comprendre ce que Google privilégie.`,
    },
    userIntentTooltipTitle: {
      en: 'User intent',
      fr: `Intention de l'utilisateur`,
    },
    userIntentTooltipDescription: {
      en: 'Shows whether the query is to buy (Transactional), learn (Informational), browse (Navigational), or explore options (Commercial).',
      fr: `Montre si la requête est pour acheter (Transactionnel), apprendre (Informationnel), naviguer (Navigational), ou explorer des options (Commercial).`,
    },
    pageType: {
      en: 'Competitors SEO page types',
      fr: 'Pages les mieux classées',
    },
    pageTypeTooltipTitle: {
      en: 'Page type',
      fr: 'Type de page',
    },
    pageTypeTooltipDescription: {
      en: 'Tells what kind of page ranks (e.g., product, collection).',
      fr: 'Indique le type de page qui se classe (e.g., produit, collection).',
    },
    competitorWordCount: {
      en: 'Words in this content.',
      fr: 'Nombre de mots dans ce contenu.',
    },
    competitorScore: {
      en: 'Blym SEO score (0–100).',
      fr: 'Score SEO de Blym (0–100).',
    },
    numberOfWords: {
      en: '{{count}} words',
      fr: '{{count}} mots',
    },
    searchResultInsightTooltipTitle: {
      en: 'SERP (Search Engine Results Page)',
      fr: 'SERP (Page de résultats de moteur de recherche)',
    },
    searchResultInsightTooltipDescription: {
      en: 'SERP Analysis reviews the competitors SEO for a keyword to understand what Google prioritizes.',
      fr: `L'analyse SERP examine les concurrents SEO pour un mot-clé afin de comprendre ce que Google privilégie.`,
    },
    competitionTitleTooltipTitle: {
      en: 'Competitors SEO',
      fr: 'Concurrents SEO',
    },
    competitionTitleTooltipDescription: {
      en: 'Pages currently ranking on Google for this keyword.',
      fr: 'Pages actuellement classées sur Google pour ce mot-clé.',
    },
  },
  'components.buttons.ai-assistant-button': {
    askAiAssistant: {
      en: 'Ask {{ name }}',
      fr: 'IA {{ name }}',
    },
  },
  'components.no-credits-dialog': {
    noCreditsLeft: {
      en: 'No credits left',
      fr: 'Plus de crédits',
    },
    topUpCredits: {
      en: 'Top-up your credits to create new content.',
      fr: 'Rechargez vos crédits pour créer un nouveau contenu.',
    },
    buyCredits: {
      en: 'Buy credits',
      fr: 'Acheter des crédits',
    },
  },
  'components.plan-card': {
    bestValue: {
      en: 'Best value',
      fr: 'Offre idéale',
    },
    applyPromoCode: {
      en: 'Apply promo code',
      fr: 'Appliquer le code promo',
    },
    enterPromoCode: {
      en: 'Enter promo code',
      fr: 'Entrer le code promo',
    },
    billedMonthly: {
      en: 'Pay as you go',
      fr: 'Payer à la carte',
    },
    billedYearly: {
      en: 'Billed yearly',
      fr: 'Facturé annuellement',
    },
    perMonth: {
      en: 'monthly',
      fr: 'mensuel',
    },
    perYear: {
      en: 'yearly',
      fr: 'annuel',
    },
    apply: {
      en: 'Apply',
      fr: 'Appliquer',
    },
    percentOff: {
      en: '{{ percent }}% off',
      fr: '{{ percent }}% de réduction',
    },
    currentPlan: {
      en: 'Current plan',
      fr: 'Plan actuel',
    },
  },

  'components.current-plan-card': {
    enterpriseSubscription: {
      en: 'Enterprise Subscription',
      fr: 'Abonnement Entreprise',
    },
    currentPlan: {
      en: 'Current plan',
      fr: 'Plan actuel',
    },
    monthly: {
      en: 'monthly',
      fr: 'mensuellement',
    },
    yearly: {
      en: 'yearly',
      fr: 'annuellement',
    },
    trial: {
      en: 'Free trial active',
      fr: 'Essai gratuit actif',
    },
    perMonth: {
      en: '/per month',
      fr: 'mensuellement',
    },
    perYear: {
      en: '/per year',
      fr: 'annuellement',
    },
    billedAnnually: {
      en: 'Billed annually at {{ price }}',
      fr: 'Facturé annuellement à {{ price }}',
    },
    renewsOn: {
      en: 'Renews on {{ date }}',
      fr: 'Renouvelé le {{ date }}',
    },
    freeTrialEndsOn: {
      en: 'Free trial ends {{ date }}',
      fr: "Fin de l'essai gratuit le {{ date }}",
    },
    switchToYearly: {
      en: 'Switch to Yearly',
      fr: "Passer à l'annuel",
    },
    switchToMonthly: {
      en: 'Switch to Monthly ',
      fr: 'Passer au mensuel',
    },
    updatePaymentMethod: {
      en: 'Update payment method',
      fr: 'Mettre à jour le mode de paiement',
    },
    reactivatePlan: {
      en: 'Reactivate plan',
      fr: 'Réactiver le plan',
    },
    paymentFailed: {
      en: 'Payment failed',
      fr: 'Paiement échoué',
    },
    accessExpiresOn: {
      en: 'Access expires on <strong>{{ date }}</strong>',
      fr: 'Accès expire le <strong>{{ date }}</strong>',
    },
  },
  'components.time-to-choose-plan-dialog': {
    title: {
      en: 'Time to choose a plan',
      fr: 'Choisissez votre abonnement',
    },
    description: {
      en: 'You’ve used your 1 free credit! Please upgrade to a plan to continue writing.',
      fr: 'Vous avez utilisé votre 1 crédit gratuit ! Veuillez mettre à niveau pour un plan pour continuer à écrire.',
    },
    aiPowered: {
      en: 'AI-powered SEO Writer',
      fr: 'Assistant IA',
    },
    aiPoweredDescription: {
      en: 'Generate content with AI-powered SEO tools',
      fr: 'Créez du contenu SEO grâce aux automatisations..',
    },
    liveSeoScore: {
      en: 'Live SEO Score',
      fr: 'Score SEO en direct',
    },
    liveSeoScoreDescription: {
      en: 'Get content ranking and optimization tips.',
      fr: 'Faites des modifications rapides et enregistrez des requêtes pour les réutiliser.',
    },
    serpAnalysis: {
      en: 'SERP Analysis',
      fr: 'Analyse SERP',
    },
    serpAnalysisDescription: {
      en: 'Uncover keyword and competitor insights.',
      fr: 'Découvrez les informations sur vos termes et vos concurrents.',
    },
    inEditorAI: {
      en: 'In-editor AI',
      fr: 'Editeur IA',
    },
    inEditorAIDescription: {
      en: 'Make quick edits and save prompts to reuse.',
      fr: 'Faites des modifications rapides et enregistrez des requêtes pour réutiliser.',
    },
    maybeLater: {
      en: 'Maybe later',
      fr: 'Plus tard',
    },
    subscribeAltImg: {
      en: 'Subscribe windows',
      fr: 'Fenêtre de souscription',
    },
    subscribe: {
      en: 'Subscribe',
      fr: 'Souscrire',
    },
  },
  'components.select-popover': {
    clearSelection: {
      en: 'Clear selection',
      fr: 'Effacer la sélection',
    },
    other: {
      en: 'Other',
      fr: 'Autre',
    },
  },
  'components.brands-nav': {
    websiteUnspecified: {
      en: 'Website unspecified',
      fr: 'Site web non spécifié',
    },
    brands: {
      en: 'Brands',
      fr: 'Marques',
    },
    addBrand: {
      en: 'Add brand',
      fr: 'Ajouter une marque',
    },
  },
  'components.keywords-dropdown': {
    primaryKeyword: {
      en: 'Primary keyword',
      fr: 'Mot-clé principal',
    },
    secondaryKeywords: {
      en: 'Secondary keywords',
      fr: 'Termes secondaires',
    },
    secondaryKeywordsDescription: {
      en: 'Secondary keywords are variations of primary keywords and contribute equally to the SEO score.',
      fr: 'Les termes secondaires sont des variations des termes principaux et contribuent de manière égale au score SEO.',
    },
    basicInformation: {
      en: 'Basic information',
      fr: 'Informations de base',
    },
    lastEdited: {
      en: 'Last edited',
      fr: 'Dernière modification',
    },
    addKeyword: {
      en: 'Add keyword',
      fr: 'Ajouter un mot-clé',
    },
  },
  'components.modal-export-success': {
    title: {
      en: 'Exported successfully!',
      fr: 'Exporté avec succès!',
    },
    subtitle: {
      en: 'Your content was successfully exported and added to {{name}}',
      fr: 'Votre contenu a été exporté et ajouté à {{name}}',
    },
    ok: {
      en: 'Ok',
      fr: 'Ok',
    },
    viewIt: {
      en: 'View it',
      fr: 'Voir',
    },
  },
  'components.export-shopify-dialog': {
    title: {
      en: 'Exporting to Shopify',
      fr: 'Exporter vers Shopify',
    },
    blogLabel: {
      en: 'Blog',
      fr: 'Blog',
    },
    blogPlaceholder: {
      en: 'Select a blog',
      fr: 'Sélectionner un blog',
    },
    blogLoading: {
      en: 'Loading blogs…',
      fr: 'Chargement des blogs…',
    },
    blogLoadError: {
      en: 'Failed to load blogs. Please close and try again.',
      fr: 'Impossible de charger les blogs. Veuillez fermer et réessayer.',
    },
    blogEmptyError: {
      en: 'No blogs found in this store. Create a blog in Shopify first.',
      fr: "Aucun blog trouvé dans cette boutique. Créez d'abord un blog dans Shopify.",
    },
    visibilityLabel: {
      en: 'Visibility',
      fr: 'Visibilité',
    },
    visibilityVisible: {
      en: 'Visible',
      fr: 'Visible',
    },
    visibilityHidden: {
      en: 'Hidden',
      fr: 'Masqué',
    },
    articleHandleLabel: {
      en: 'Article handle (optional)',
      fr: "Identifiant de l'article (optionnel)",
    },
    articleHandlePlaceholder: {
      en: 'my-article-handle',
      fr: 'mon-identifiant-article',
    },
    export: {
      en: 'Export',
      fr: 'Exporter',
    },
    exporting: {
      en: 'Exporting',
      fr: 'Exportation',
    },
    exportSuccess: {
      en: 'Exported successfully',
      fr: 'Exporté avec succès',
    },
  },
  'components.export-bloggle-dialog': {
    title: {
      en: 'Exporting to Bloggle',
      fr: 'Exporter vers Bloggle',
    },
    export: {
      en: 'Export',
      fr: 'Exporter',
    },
    exporting: {
      en: 'Exporting',
      fr: 'Exportation',
    },
    exportSuccess: {
      en: 'Exported successfully',
      fr: 'Exporté avec succès',
    },
  },
  'components.export-wordpress-dialog': {
    title: {
      en: 'Exporting to WordPress',
      fr: 'Exporter vers WordPress',
    },
    postSlugLabel: {
      en: 'Post slug',
      fr: "Identifiant de l'article",
    },
    postSlugPlaceholder: {
      en: 'my-post-slug',
      fr: 'mon-identifiant',
    },
    postSlugInvalid: {
      en: 'Only lowercase letters, numbers, and hyphens allowed',
      fr: 'Uniquement des lettres minuscules, chiffres et tirets',
    },
    authorLabel: {
      en: 'Author',
      fr: 'Auteur',
    },
    statusLabel: {
      en: 'Status',
      fr: 'Statut',
    },
    statusDraft: {
      en: 'Draft',
      fr: 'Brouillon',
    },
    statusPublished: {
      en: 'Published',
      fr: 'Publié',
    },
    export: {
      en: 'Export',
      fr: 'Exporter',
    },
    exporting: {
      en: 'Exporting',
      fr: 'Exportation',
    },
    noAuthorsError: {
      en: 'No authors with post-creation rights found on this WordPress site',
      fr: "Aucun auteur avec les droits de création d'article trouvé sur ce site WordPress",
    },
    exportSuccess: {
      en: 'Exported successfully',
      fr: 'Exporté avec succès',
    },
  },
  'components.content-header': {
    subscribeToExport: {
      en: 'Subscribe to export',
      fr: 'Souscrivez pour exporter du contenu',
    },
    export: {
      en: 'Export',
      fr: 'Exporter',
    },
    integrations: {
      en: 'Integrations',
      fr: 'Intégrations',
    },
    comingSoon: {
      en: 'Coming soon',
      fr: 'À venir',
    },
    voteIntegration: {
      en: 'Vote for your integration',
      fr: 'Vote pour votre intégration',
    },
    learnHowToExport: {
      en: 'Learn how to export',
      fr: 'Comment exporter du contenu ?',
    },
    download: {
      en: 'Download',
      fr: 'Télécharger',
    },
    copyToClipboard: {
      en: 'Copy to clipboard',
      fr: 'Copier dans le presse-papiers',
    },
    downloadHtml: {
      en: 'Download HTML',
      fr: 'Télécharger HTML',
    },
    downloadMarkdown: {
      en: 'Download Markdown',
      fr: 'Télécharger Markdown',
    },
    downloadPDF: {
      en: 'Download PDF',
      fr: 'Télécharger PDF',
    },
    copyHtml: {
      en: 'Copy HTML',
      fr: 'Copier HTML',
    },
    copyRichText: {
      en: 'Copy for Google Docs or CMS',
      fr: 'Copier pour Google Docs ou CMS',
    },
    copyMarkdown: {
      en: 'Copy Markdown',
      fr: 'Copier Markdown',
    },
    copyText: {
      en: 'Copy Text',
      fr: 'Copier le texte',
    },
    copiedToClipboardRichTextTitle: {
      en: 'Copied to clipboard',
      fr: 'Copié dans le presse-papiers',
    },
    copiedToClipboardRichTextDescription: {
      en: 'You can now paste it into any editor or document',
      fr: "Vous pouvez maintenant le coller dans n'importe quel éditeur ou document",
    },
    copiedToClipboardHTMLTitle: {
      en: 'HTML copied to clipboard',
      fr: 'HTML copié dans le presse-papiers',
    },
    copiedToClipboardHTMLDescription: {
      en: 'You can now paste it into your CMS or HTML editor',
      fr: 'Vous pouvez maintenant le coller dans votre CMS ou éditeur HTML',
    },
    copiedToClipboardMarkdownTitle: {
      en: 'Markdown copied to clipboard',
      fr: 'Markdown copié dans le presse-papiers',
    },
    copiedToClipboardMarkdownDescription: {
      en: 'You can now paste it into your Markdown editor',
      fr: 'Vous pouvez maintenant le coller dans votre éditeur Markdown',
    },
    noteTitle: {
      en: 'Note:',
      fr: 'Note:',
    },
    note: {
      en: 'Meta title & description will not be included in the file',
      fr: 'Les titres et descriptions Meta ne seront pas inclus dans le fichier',
    },
    errorMissingContentId: {
      en: 'Invalid content',
      fr: 'Contenu invalide',
    },
    errorWithExport: {
      en: 'Failed to export content',
      fr: `Échec de l'exportation du contenu`,
    },
    copied: {
      en: 'Copied to clipboard',
      fr: 'Copié dans le presse-papiers',
    },
    downloaded: {
      en: 'Your file has been downloaded',
      fr: 'Votre fichier a été téléchargé',
    },
    fileNote: {
      en: 'Note: Meta title & description will not be included in the file',
      fr: 'Remarque: Le titre méta et la description ne seront pas inclus dans le fichier',
    },
  },
  'components.bubble-menu-selector': {
    bold: {
      en: 'Bold',
      fr: 'Gras',
    },
    italic: {
      en: 'Italic',
      fr: 'Italique',
    },
    underline: {
      en: 'Underline',
      fr: 'Souligné',
    },
    strikethrough: {
      en: 'Strikethrough',
      fr: 'Barré',
    },
    alignment: {
      en: 'Alignment',
      fr: 'Alignement',
    },
    unsetLink: {
      en: 'Unset link',
      fr: 'Supprimer',
    },
  },
  'app.content.-editor.add-link': {
    title: {
      en: 'Create link',
      fr: 'Créer un lien',
    },
    text: {
      en: 'Text',
      fr: 'Texte',
    },
    textPlaceholder: {
      en: 'Add text',
      fr: 'Ajouter du texte',
    },
    url: {
      en: 'URL',
      fr: 'URL',
    },
    urlPlaceholder: {
      en: 'https://example.com',
      fr: 'https://exemple.com',
    },
    openLinkInNewTab: {
      en: 'Open link in new tab',
      fr: 'Ouvrir le lien dans un nouvel onglet',
    },
    unsetLink: {
      en: 'Unset link',
      fr: 'Supprimer',
    },
  },
  'app.content.-editor.add-image': {
    addImage: {
      en: 'Add image',
      fr: 'Ajouter une image',
    },
    updateImage: {
      en: 'Update image',
      fr: `Mettre à jour l'image`,
    },
    altText: {
      en: 'Alt-text',
      fr: 'Texte alternatif',
    },
    altTextPlaceholder: {
      en: 'Alt-text',
      fr: 'Texte alternatif',
    },
    url: {
      en: 'URL',
      fr: 'URL',
    },
    urlPlaceholder: {
      en: 'https://example.com/image',
      fr: 'https://exemple.com/image',
    },
  },
  'app.content.-editor.add-new-term': {
    addNewTerm: {
      en: 'Add new term',
      fr: 'Ajouter un nouveau terme',
    },
    modalDescription: {
      en: 'Modal to add new term',
      fr: 'Fenêtre modale pour ajouter un nouveau terme',
    },
    addTerm: {
      en: 'Add term',
      fr: 'Ajouter le terme',
    },
    termPlaceholder: {
      en: 'e.g. SEO',
      fr: 'ex: SEO',
    },
    termLabel: {
      en: 'Term',
      fr: 'Terme',
    },
    usageRangeLabel: {
      en: 'Usage range',
      fr: `Plage d'utilisation`,
    },
    usageRangeDescription: {
      en: 'Define a usage range to ensure the term is being used appropriately and consistently.',
      fr: `Définissez une plage d'utilisation pour garantir que le terme est utilisé de manière appropriée et cohérente.`,
    },
    pleaseEnterATerm: {
      en: 'Please enter a term',
      fr: 'Veuillez saisir un terme',
    },
    pleaseEnterUsageRange: {
      en: 'Please enter usage range',
      fr: `Veuillez saisir la plage d'utilisation`,
    },
  },
  'app.content.-editor.removed-terms': {
    removedTerms: {
      en: 'Removed terms',
      fr: 'Termes supprimés',
    },
    returnLabel: {
      en: 'Return to terms panel',
      fr: 'Retourner au panneau des termes',
    },
    emptyCopy: {
      en: 'The removed terms will appear here.',
      fr: 'Les termes supprimés apparaîtront ici.',
    },
    addBack: {
      en: 'Add back',
      fr: 'Rétablir',
    },
    addTermBackToTerms: {
      en: 'Add term back to terms.',
      fr: 'Remettre le mot-clé dans la liste',
    },
  },
  'components.indicators.circle-progress': {
    taskCompleted: {
      en: 'Task completed',
      fr: 'Tâche terminée',
    },
    taskInProgress: {
      en: '{{progress}}% complete',
      fr: '{{progress}}% terminé',
    },
    completed: {
      en: 'Completed',
      fr: 'Terminé',
    },
  },
  'components.indicators.range-indicator': {
    textLabel: {
      en: 'Range from {{rangeStart}} to {{rangeEnd}} out of {{min}} to {{max}}',
      fr: 'De {{rangeStart}} à {{rangeEnd}} sur {{min}} à {{max}}',
    },
  },
  'components.inputs.range-input': {
    rangeInputMinPlaceholder: {
      en: 'e.g. 1',
      fr: 'ex: 1',
    },
    rangeInputMaxPlaceholder: {
      en: 'e.g. 5',
      fr: 'ex: 5',
    },
  },
  'shared.utils': {
    article: {
      en: 'Article',
      fr: 'Article',
    },
    product: {
      en: 'Product',
      fr: 'Produit',
    },
  },
  'shared.seo-rules': {
    headingsH1Count0Title: {
      en: 'Missing h1 heading',
      fr: 'En-tête h1 manquant',
    },
    headingsH1Count0Description: {
      en: 'Your content needs one main h1 heading',
      fr: 'Votre contenu doit avoir un en-tête h1 principal',
    },
    headingsH1CountOver1Title: {
      en: 'Too many h1 headings',
      fr: 'Trop de titres h1',
    },
    headingsH1CountOver1Description: {
      en: 'Your content should only have one h1 heading',
      fr: 'Votre contenu doit avoir un seul titre h1',
    },
    headingsH1Count1Title: {
      en: 'One h1 in the content',
      fr: 'Un titre h1 dans le contenu',
    },
    headingsH1Count1Description: {
      en: 'Perfect! Your heading structure is correct',
      fr: 'Parfait ! Votre structure de titres est correcte',
    },
    headingsKeywordInH1Title: {
      en: 'Target keyword in h1',
      fr: 'Mot-clé cible dans h1',
    },
    headingsKeywordInH1Description: {
      en: 'The target keyword is in the H1',
      fr: "Le mot-clé cible est dans l'en-tête h1",
    },
    headingsKeywordInH1NoKeywordsFoundTitle: {
      en: 'Missing target keyword in h1',
      fr: 'Mot-clé cible manquant dans h1',
    },
    headingsKeywordInH1NoKeywordsFoundDescription: {
      en: 'Add the target keyword to the H1 heading',
      fr: "Ajouter le mot-clé cible à l'en-tête h1",
    },
    headingsKeywordInH2Title: {
      en: 'Target keyword in h2',
      fr: 'Mot-clé cible dans h2',
    },
    headingsKeywordInH2Description: {
      en: 'The target keyword is in the H2',
      fr: "Le mot-clé cible est dans l'en-tête h2",
    },
    headingsKeywordInH2NoKeywordsFoundTitle: {
      en: 'Missing target keyword in h2',
      fr: 'Mot-clé cible manquant dans h2',
    },
    headingsKeywordInH2NoKeywordsFoundDescription: {
      en: 'Add the target keyword to the H2 heading',
      fr: "Ajouter le mot-clé cible à l'en-tête h2",
    },
    h2andh3Title: {
      en: 'Number of subheadings',
      fr: 'Nombre de titres secondaires',
    },
    h2andh3Description: {
      en: 'The subheadings structure is optimized',
      fr: 'La structure des titres secondaires est optimisée',
    },
    h2andh3UnderDescription: {
      en: 'Add subheadings (H2 or H3) to be closer to the competition',
      fr: 'Ajouter des titres secondaires (H2 ou H3) pour être plus proche de la concurrence',
    },
    h2andh3OverDescription: {
      en: 'Remove subheadings (H2 or H3) to be closer to the competition',
      fr: 'Supprimer des titres secondaires (H2 ou H3) pour être plus proche de la concurrence',
    },
    keywordInTitleTitle: {
      en: 'Target keyword in the meta title',
      fr: 'Mot-clé cible dans le titre SEO',
    },
    keywordInTitleDescription: {
      en: 'The target keyword is in the meta title',
      fr: 'Le mot-clé cible est dans le titre SEO',
    },
    keywordInTitleNoKeywordsFoundDescription: {
      en: 'Add the target keyword to the meta title',
      fr: 'Ajouter le mot-clé cible au titre SEO',
    },
    metaDescriptionTitle: {
      en: 'Meta description length',
      fr: 'Longueur du meta description',
    },
    metaDescriptionDescription: {
      en: 'The meta description is optimized',
      fr: 'Le meta description est optimisé',
    },
    metaDescriptionUnderDescription: {
      en: 'The meta description is too short. Adjust it to be between 130 and 160 characters',
      fr: 'Le meta description est trop court. Visez entre 130 et 160 caractères',
    },
    metaDescriptionOverDescription: {
      en: 'The meta description is too long. Adjust it to be between 130 and 160 characters',
      fr: 'Le meta description est trop long. Visez entre 130 et 160 caractères',
    },
    metaTitleTitle: {
      en: 'Meta title length',
      fr: 'Longueur du titre SEO',
    },
    metaTitleDescription: {
      en: 'The meta title is optimized',
      fr: 'Le titre SEO est optimisé',
    },
    metaTitleUnderDescription: {
      en: 'The meta title is too short. Adjust it to be between 50 and 60 characters',
      fr: 'Le titre SEO est trop court. Visez entre 50 et 60 caractères',
    },
    metaTitleOverDescription: {
      en: 'The meta title is too long. Adjust it to be between 50 and 60 characters',
      fr: 'Le titre SEO est trop long. Visez entre 50 et 60 caractères',
    },
    contentLengthTitle: {
      en: 'Content length',
      fr: 'Longueur du contenu',
    },
    contentLengthDescription: {
      en: 'The content length is optimized',
      fr: 'La longueur du contenu est optimisée',
    },
    contentLengthUnderDescription: {
      en: 'Keep the content under {{count}} words',
      fr: 'Gardez le contenu sous {{count}} mots',
    },
    contentLengthOverDescription: {
      en: 'Expand the content to at least {{count}} words',
      fr: 'Développez le contenu à au moins {{count}} mots',
    },
    strongsTitle: {
      en: 'Bold text (<strong> tags)',
      fr: 'Texte en gras (<strong> balises)',
    },
    strongsUnderDescription: {
      en: 'Use between {{underAvgLength}} and {{overAvgLength}} bold (strong) tags',
      fr: 'Utilisez entre {{underAvgLength}} et {{overAvgLength}} balises gras (strong)',
    },
    strongsOverDescription: {
      en: 'Use fewer than {{overAvgLength}} bold (strong) tags',
      fr: 'Utilisez moins de {{overAvgLength}} balises gras (strong)',
    },
    strongsSuccessDescription: {
      en: 'The bold text is optimized',
      fr: 'Le texte en gras est optimisé',
    },
    keywordStuffingTitle: {
      en: 'Target keyword usage',
      fr: 'Utilisation du mot-clé cible',
    },
    keywordStuffingNotEnoughKeywordsDescription: {
      en: 'Add the target keyword at least {{minimumCount}} times',
      fr: 'Ajouter le mot-clé cible au moins {{minimumCount}} fois',
    },
    keywordStuffingTooManyKeywordsDescription: {
      en: 'Reduce keyword usage to avoid stuffing',
      fr: "Réduire l'utilisation du mot-clé pour éviter le stuffing",
    },
    keywordStuffingSuccessDescription: {
      en: 'The keyword usage is balanced',
      fr: "L'utilisation du mot-clé est équilibrée",
    },
    termsTitle: {
      en: 'Semantic terms optimization',
      fr: 'Optimisation des termes sémantiques',
    },
    termsNoSemanticTermsDescription: {
      en: 'The content should contain {{semanticTermsLength}} terms',
      fr: 'Le contenu doit contenir {{semanticTermsLength}} termes',
    },
    termsAreOptimizedDescription: {
      en: 'The content semantic is optimized',
      fr: 'La sémantique du contenu est optimisée',
    },
    termsTooltip: {
      en: 'Check the Terms tab for a list of words to add in the content.',
      fr: "Consultez l'onglet Termes pour une liste de termes à ajouter dans le contenu.",
    },
    internalLinksTitle: {
      en: 'Internal links',
      fr: 'Liens internes',
    },
    internalLinksDescription: {
      en: 'Add at least {{expectedCount}} internal links.',
      fr: 'Ajouter au moins {{expectedCount}} liens internes.',
    },
    internalLinksTooltip: {
      en: 'Links to pages on your website.',
      fr: 'Liens vers les pages de votre site web.',
    },
    externalLinkTitle: {
      en: 'External links',
      fr: 'Liens externes',
    },
    externalLinksDescription: {
      en: 'Add at least {{expectedCount}} external links.',
      fr: 'Ajouter au moins {{expectedCount}} liens externes.',
    },
    externalLinksTooltip: {
      en: 'Links to pages on other websites.',
      fr: 'Liens vers les pages de sites web externes.',
    },
    globalLinksTitle: {
      en: 'Global links',
      fr: 'Liens globaux',
    },
    globalLinksDescription: {
      en: 'Add at least {{expectedCount}} links.',
      fr: 'Ajouter au moins {{expectedCount}} liens.',
    },
  },
  'shared.tiptap.custom-extensions.outline-heading-view': {
    newHeading: {
      en: 'New heading',
      fr: 'Nouveau titre',
    },
    heading: {
      en: 'Heading {{level}} ({{tag}})',
      fr: 'Titre {{level}} ({{tag}})',
    },
  },
  'shared.tiptap-custom-extensions.content-paragraph': {
    editorPlaceholder: {
      en: 'Write or paste your content',
      fr: 'Écrivez ou collez votre contenu',
    },
  },
  'shared.tiptap-custom-extensions.content-heading': {
    placeholder: {
      en: 'Write or paste your heading',
      fr: 'Écrivez ou collez votre titre',
    },
  },
  'shared.tiptap-custom-extensions.content-image-view': {
    cannotLoadImage: {
      en: `We couldn't load your image`,
      fr: `Nous n'avons pas pu charger votre image`,
    },
    deleteImage: {
      en: 'Delete this image',
      fr: 'Supprimer cette image',
    },
    editImage: {
      en: 'Edit this image',
      fr: 'Modifier cette image',
    },
  },
  'shared.tiptap-custom-extensions.content-table-utilities': {
    toggleFirstCellHeading: {
      en: 'Toggle first cell heading',
      fr: `Basculer l'en-tête de la première cellule`,
    },
    addColumnLeft: {
      en: 'Add column to the left',
      fr: 'Ajouter une colonne à gauche',
    },
    addColumnRight: {
      en: 'Add column to the right',
      fr: 'Ajouter une colonne à droite',
    },
    deleteColumn: {
      en: 'Delete column',
      fr: 'Supprimer la colonne',
    },
    addRowAbove: {
      en: 'Add row above',
      fr: 'Ajouter une ligne au-dessus',
    },
    addRowBelow: {
      en: 'Add row below',
      fr: 'Ajouter une ligne en dessous',
    },
    deleteRow: {
      en: 'Delete row',
      fr: 'Supprimer la ligne',
    },
    header: {
      en: 'Header',
      fr: 'En-tête',
    },
    makeFirstColumnHeader: {
      en: 'Make first column header',
      fr: 'Définir la première colonne comme en-tête',
    },
    makeFirstRowHeader: {
      en: 'Make first row header',
      fr: 'Définir la première ligne comme en-tête',
    },
    omitHeader: {
      en: 'Omit header',
      fr: `Omettre l'en-tête`,
    },
    duplicate: {
      en: 'Duplicate',
      fr: 'Dupliquer',
    },
    copyToClipboard: {
      en: 'Copy to clipboard',
      fr: 'Copier dans le presse-papiers',
    },
    deleteTable: {
      en: 'Delete table',
      fr: 'Supprimer le tableau',
    },
    tableOptions: {
      en: 'Table options',
      fr: 'Options de tableau',
    },
    addColumn: {
      en: 'Add column',
      fr: 'Ajouter une colonne',
    },
    addRow: {
      en: 'Add row',
      fr: 'Ajouter une ligne',
    },
    selectColumn: {
      en: 'Select column',
      fr: 'Sélectionner la colonne',
    },
    selectRow: {
      en: 'Select row',
      fr: 'Sélectionner la ligne',
    },
  },
  'app.funnel.$id._layout-funnel': {
    loadingStep: {
      en: 'Generating {{step}}...',
      fr: 'Génération de {{step}}...',
    },
    outlinesBody: {
      en: 'This may take up to <0>2 minute</0>. You can leave the page and come back later.',
      fr: `Cela peut prendre jusqu'à <0>2 minute</0>. Vous pouvez quitter la page et revenir plus tard.`,
    },
    contentBody: {
      en: 'This may take between <0>3 to 5 minutes</0>. You can leave the page and come back later.',
      fr: 'Cela peut prendre entre <0>3 et 5 minutes</0>. Vous pouvez quitter la page et revenir plus tard.',
    },
    titleBody: {
      en: 'This may take <0>less than a minute</0>.',
      fr: `Cela devrait prendre <0>moins d'une minute</0>.`,
    },
    generatingTitle: {
      en: 'Generating title...',
      fr: 'Génération du titre...',
    },
    generatingOutlines: {
      en: 'Generating outlines...',
      fr: 'Génération des plans...',
    },
    generatingContent: {
      en: 'Generating content...',
      fr: 'Génération du contenu...',
    },
  },
  'app.contentCreationFunnel': {
    generateOutline: {
      en: 'Generate outline',
      fr: 'Générer le plan',
    },
  },
  'app.contentCreationFunnel-headings': {
    customHeadingPlaceholder: {
      en: '+ Add custom heading',
      fr: '+ Ajouter un en-tête personnalisé',
    },
  },
  'app.funnel-title': {
    selectTitle: {
      en: 'Select your title',
      fr: 'Sélectionnez votre titre',
    },
    h1Description: {
      en: 'This will be used as the <h1> of your content',
      fr: 'Cela sera utilisé comme <h1> de votre contenu',
    },
    generatingTitles: {
      en: 'Generating titles...',
      fr: 'Génération de titres...',
    },
    contentNotFound: {
      en: 'Content not found',
      fr: 'Contenu non trouvé',
    },
    thisMightTakeAWhile: {
      en: 'This might take a few minutes, you can leave the page and come back later.',
      fr: 'Cela peut prendre quelques minutes, vous pouvez quitter la page et revenir plus tard.',
    },
    titleIsRequired: {
      en: 'Select a title or write your own before generating outlines',
      fr: 'Sélectionnez un titre ou écrivez le votre avant de générer les plans',
    },
    noContentFunnelFound: {
      en: 'No content funnel found',
      fr: 'Aucun contenu de funneling trouvé',
    },
  },
  'app.funnel-customize-content': {
    customizeContentBrief: {
      en: 'Customize your content brief',
      fr: 'Personnalisez votre brief de contenu',
    },
    customizeContentBriefDescription: {
      en: 'Define what the content should say and how it should be structured.',
      fr: 'Définissez ce que le contenu doit dire et comment il doit être structuré.',
    },
    brandContext: {
      en: 'Brand context',
      fr: 'Brand context',
    },
    useBrandContext: {
      en: 'Use brand context to apply your saved tone and style.',
      fr: 'Utiliser le brand context pour appliquer votre ton et votre style enregistrés.',
    },
    updateBrandContext: {
      en: 'Edit',
      fr: 'Modifier',
    },
    mentionBrandIn: {
      en: 'Where to explicitly mention your brand:',
      fr: 'Où mentionner explicitement votre marque:',
    },
    introduction: {
      en: 'Introduction',
      fr: 'Introduction',
    },
    body: {
      en: 'Body',
      fr: 'Corps',
    },
    conclusion: {
      en: 'Conclusion',
      fr: 'Conclusion',
    },
    informationforIA: {
      en: 'Information for the AI',
      fr: "Informations pour l'IA",
    },
    contentDirection: {
      en: 'Content direction (optional)',
      fr: 'Direction du contenu (optionnel)',
    },
    contentDirectionTooltipTitle: {
      en: 'Content direction',
      fr: 'Direction du contenu',
    },
    contentDirectionLabel: {
      en: 'Guidelines & knowledge',
      fr: 'Instructions et expertise',
    },
    contentDirectionTooltipDescription: {
      en: 'Use this field to guide the AI with your intended angle or focus. E.g: We are a luxury brand, so do not recommend using dish soap on our products.',
      fr: "Utilisez ce champ pour guider l'IA avec votre angle ou votre focus. E.g: Nous sommes une marque de luxe, donc ne recommandons pas d'utiliser le savon de cuisine sur nos produits.",
    },
    contentDirectionPlaceholder: {
      en: 'Share your expertise: insights, data, specific angles, or unique knowledge about the topic. The more specific you are, the better the output.',
      fr: 'Partagez votre expertise : insights, données, angles spécifiques ou connaissances sur le sujet afin d’améliorer la pertinence de votre contenu. Plus vous êtes spécifique, meilleur sera le résultat.',
    },
    contentDirectionDescription: {
      en: 'Provide key guidelines that the AI should follow.',
      fr: "Indiquez les principales instructions que l'IA doit suivre.",
    },
    quickFill: {
      en: 'Quick fill',
      fr: 'Remplissage rapide',
    },
    recommended: {
      en: 'Recommended',
      fr: 'Recommandé',
    },
    linkToTargetPages: {
      en: 'Link to target pages',
      fr: 'Lien vers les pages cibles',
    },
    linkToTargetPagesValue: {
      en: 'Specify the pages you want this content to link to (URLs):',
      fr: 'Spécifiez les pages vers lesquelles vous souhaitez que ce contenu pointe (URLs):',
    },
    addCallToAction: {
      en: 'Add a call-to-action',
      fr: "Ajouter un appel à l'action",
    },
    addCallToActionValue: {
      en: 'Call-to-action:\n- Describe the primary action you want readers to take (sign up, book a demo, download, etc.):\n- Link (URL):',
      fr: "Appel à l'action:\n- Décrivez l'action principale que vous souhaitez que les lecteurs effectuent (inscription, réserver une démo, télécharger, etc.):\n- Lien (URL):",
    },
    readerAwareness: {
      en: 'Reader awareness',
      fr: 'Niveau de connaissance du lecteur',
    },
    readerAwarenessValue: {
      en: 'Reader awareness:\nHow familiar is the reader with the topic (new to the topic, familiar, expert audience)?',
      fr: 'Niveau de connaissance du lecteur:\nQuel est le niveau de familiarité du lecteur avec le sujet (nouveau sur le sujet, familier, audience experte)?',
    },
    opinionsAllowed: {
      en: 'Opinions allowed',
      fr: 'Opinions autorisées',
    },
    opinionsAllowedValue: {
      en: 'Opinions:\nShould the content take a clear stance (Yes, strong opinions or neutral)?',
      fr: 'Opinions:\nLe contenu doit-il prendre une position claire (Oui, opinions fortes ou neutre)?',
    },
    listicleBrief: {
      en: 'Listicle brief',
      fr: 'Brief listicle',
    },
    listicleBriefValue: {
      en: 'Listicle brief:\n- Number of items to include:\n- Names of competitors or items (comma-separated):\n- Ranking or evaluation criteria:',
      fr: "Brief listicle:\n- Nombre d'éléments à inclure:\n- Noms des concurrents ou éléments (séparés par des virgules):\n- Critères de classement ou d'évaluation:",
    },
    vsPageBrief: {
      en: 'VS page brief',
      fr: 'Brief page VS',
    },
    vsPageBriefValue: {
      en: 'VS page brief:\n- Products or solutions to compare (with relevant URLs):\n- Main comparison criteria:\n- Target audience (who is deciding?):\n- Your preferred outcome (neutral vs recommended option):',
      fr: 'Brief page VS:\n- Produits ou solutions à comparer (avec URLs pertinentes):\n- Principaux critères de comparaison:\n- Audience cible (qui décide?):\n- Résultat préféré (neutre vs option recommandée):',
    },
    reviewBrief: {
      en: 'Review brief',
      fr: 'Brief avis',
    },
    reviewBriefValue: {
      en: 'Review brief:\n- Product or service name:\n- Type of review (hands-on, expert opinion, user-based):\n- Sections to include (features, pros & cons, pricing, alternatives, verdict):',
      fr: "Brief avis:\n- Nom du produit ou service:\n- Type d'avis (pratique, opinion d'expert, basé sur les utilisateurs):\n- Sections à inclure (fonctionnalités, avantages et inconvénients, tarification, alternatives, verdict):",
    },
    newsBrief: {
      en: 'News brief',
      fr: 'Brief actualité',
    },
    newsBriefValue: {
      en: 'News brief:\n- News angle or key takeaway:\n- Timeline of events:\n- Type of news (breaking, recent update, evergreen analysis):',
      fr: "Brief actualité:\n- Angle de l'actualité ou point clé:\n- Chronologie des événements:\n- Type d'actualité (breaking news, mise à jour récente, analyse evergreen):",
    },
    recommanded: {
      en: 'Recommanded',
      fr: 'Recommandé',
    },
    outlineStructure: {
      en: 'Outline structure <span className="text-branding-gray"> (optional)</span>',
      fr: 'Structure du plan <span className="text-branding-gray"> (optionnel)</span>',
    },
    outlineStructureTooltipTitle: {
      en: 'Outline structure',
      fr: 'Structure du plan',
    },
    outlineStructureTooltipDescription: {
      en: 'Suggest how you’d like the content to be structured. E.g: Use H2 headings for each luxury skincare product name when comparing multiple products.',
      fr: 'Indiquez comment vous souhaitez que le contenu soit structuré. E.g: Utiliser des en-têtes H2 pour chaque nom de produit de soin de luxe lors de la comparaison de plusieurs produits.',
    },
    outlineStructurePlaceholder: {
      en: 'E.g: Use H2 headings for each luxury skincare product name when comparing multiple products',
      fr: 'E.g: Utiliser des en-têtes H2 pour chaque nom de produit de soin de luxe lors de la comparaison de plusieurs produits',
    },
    outlineStructurePlaceholderList: {
      en: `Paste your outline structure here, e.g:

H2: Introduction to [Topic]
H2: Why [Topic] Matters
  H3:Benefit 1
  H3:Benefit 2
H2: How to get started
H2: Conclusion
`,
      fr: 'E.g: Utiliser des en-têtes H2 pour chaque nom de produit de soin de luxe lors de la comparaison de plusieurs produits',
    },
    outlineStructureDescription: {
      en: 'Describe how you’d like the content to be organized.',
      fr: 'Décrivez comment vous souhaitez que le contenu soit organisé.',
    },
    extraOptions: {
      en: 'Additional sections',
      fr: 'Sections additionnelles',
    },
    generateTakeaways: {
      en: 'Summarize the article in the introduction',
      fr: 'Ajouter une section Résumé en haut de page',
    },
    generateFAQs: {
      en: 'Add FAQ section at the end',
      fr: 'Ajouter une section FAQ en bas',
    },
    faqsSectionTitle: {
      en: 'FAQs section',
      fr: 'Section des questions fréquentes',
    },
    faqsSectionDescription: {
      en: 'Adds a Frequently Asked Questions section at the bottom of your content.',
      fr: 'Ajoute une section avec des questions fréquentes à la fin de votre contenu.',
    },
    takeawaysSectionTitle: {
      en: 'Key take-aways',
      fr: 'Points clés',
    },
    takeawaysSectionDescription: {
      en: 'Creates a short summary at the beginning of your content, highlighting the main points.',
      fr: 'Crée un résumé court au début de votre contenu, mettant en évidence les points clés.',
    },
    brandContextDescriptionDefault: {
      en: 'Provide brand details to help us generate content that aligns with your brand’s voice and style.',
      fr: 'Fournissez les détails de la marque pour nous aider à générer du contenu qui correspond à la voix et au style de votre marque.',
    },
    configureBrandContext: {
      en: 'Configure brand context',
      fr: 'Configurer le brand context',
    },
    brandContextDescription: {
      en: 'Use brand context to apply your saved tone and style',
      fr: 'Utiliser le brand context pour appliquer votre ton et votre style enregistrés.',
    },
    brand: {
      en: 'Brand',
      fr: 'Marque',
    },
    voice: {
      en: 'Voice',
      fr: 'Voix',
    },
    tone: {
      en: 'Tone',
      fr: 'Ton',
    },
    keywordsBlacklisted: {
      en: 'Keywords blacklisted',
      fr: 'Termes bloqués',
    },
    typeOfBusiness: {
      en: 'Type of business',
      fr: 'Type de business',
    },
    website: {
      en: 'Website',
      fr: 'Site web',
    },
    activity: {
      en: 'Activity',
      fr: 'Activité',
    },
    brandContextUpdated: {
      en: 'Brand context updated successfully',
      fr: 'Brand context mis à jour avec succès',
    },
    brandContextUpdatedDescription: {
      en: 'Your content just got smarter!',
      fr: 'Votre contenu vient de devenir plus intelligent !',
    },
    wordCount: {
      en: 'Word count',
      fr: 'Nombre de mots',
    },
    wordCountAiOptimized: {
      en: 'Optimized by AI*',
      fr: "Optimisé par l'IA*",
    },
    wordCountCustom: {
      en: 'Custom',
      fr: 'Personnalisé',
    },
    wordCountAiOptimizedDescription: {
      en: '<span className="text-branding-accent font-body-2-m">{{wordCount}} words</span> – *Based on competitor analysis for the best chance to rank',
      fr: `<span className="text-branding-accent font-body-2-m">{{wordCount}} mots</span> – *Basé sur l'analyse de la concurrence pour avoir la meilleure chance de ranker`,
    },
    wordCountMaxError: {
      en: 'Word count cannot exceed 5000 words',
      fr: 'Le nombre de mots ne peut pas dépasser 5000 mots',
    },
    words: {
      en: 'words',
      fr: 'mots',
    },
    chooseContentType: {
      en: 'Choose your content type',
      fr: 'Choisissez votre type de contenu',
    },
    blogPost: {
      en: 'Blog post',
      fr: 'Article de blog',
    },
    blogPostDescription: {
      en: 'An informative page to share tips or knowledge.',
      fr: 'Une page informative pour partager des conseils ou des connaissances.',
    },
    listicle: {
      en: 'Listicle',
      fr: 'Listicle',
    },
    listicleDescription: {
      en: 'A page that lists, compares, and ranks multiple solutions based on different criteria.',
      fr: 'Une page qui liste, compare et classe plusieurs solutions selon différents critères.',
    },
    vsPage: {
      en: 'VsPage',
      fr: 'VsPage',
    },
    vsPageDescription: {
      en: 'A page that compares two or three solutions.',
      fr: 'Une page qui compare deux ou trois solutions.',
    },
    review: {
      en: 'Review',
      fr: 'Revue',
    },
    reviewDescription: {
      en: 'A user experience or opinion about a solution, product, or service.',
      fr: 'Un retour d’expérience sur une solution, un produit ou un service.',
    },
    news: {
      en: 'News',
      fr: 'Actualités',
    },
    newsDescription: {
      en: 'An article about recent updates in your industry or your company.',
      fr: 'Un article sur une info récente du secteur ou de votre entreprise.',
    },
    webPages: {
      en: 'Webpages',
      fr: 'Pages web',
    },
    webPagesDescription: {
      en: 'Pages, such as homepage, features, about, or any other landing page.',
      fr: "Pages de votre site web, comme l'accueil, les fonctionnalités, à propos, ou autre.",
    },
    webPageQuickFillStructureLabel: {
      en: 'Webpages structure',
      fr: 'Brief structure page',
    },
    webPageQuickFillStructureValue: {
      en: `Page structure:
- Primary goal: [SEO / Conversion / Brand awareness / Other]
- Sections to include (order + ideal length)`,
      fr: `Structure de la page :
- Objectif principal: [SEO / Conversion / Brand awareness / Autre]
- Sections à inclure (ordre + longueur idéale)`,
    },
    webPageQuickFillHomepageLabel: {
      en: 'Homepage',
      fr: 'Page accueil',
    },
    webPageQuickFillHomepageValue: {
      en: `- Product / service (1 sentence)
- Main problem solved
- 3 key benefits (bullet points)
- Proof (numbers, logos, testimonials)
- Primary CTA + secondary CTA`,
      fr: `- Produit / service (en 1 phrase)
- Problème principal résolu
- 3 bénéfices clés (bullet points) :
- Preuves (chiffres, logos, témoignages)
- CTA principal + CTA secondaire`,
    },
    webPageQuickFillFeaturesLabel: {
      en: 'Features page',
      fr: 'Page features',
    },
    webPageQuickFillFeaturesValue: {
      en: `- Feature name
- Specific problem solved
- How it works (short summary)
- 3 concrete benefits
- Example or use case`,
      fr: `- Nom de la fonctionnalité
- Problème spécifique résolu
- Comment ça marche (résumé)
- 3 bénéfices concrets
- Exemple ou cas d'usage`,
    },
    webPageQuickFillAboutLabel: {
      en: 'About us page',
      fr: 'Page à propos',
    },
    webPageQuickFillAboutValue: {
      en: `- Why the company exists (mission)
- Short story (1–3 steps)
- Values (max 3)
- What makes you different
- Credibility proof`,
      fr: `- Pourquoi l'entreprise existe (mission)
- Histoire courte (1–3 étapes)
- Valeurs (3 max)
- Ce qui vous rend différents
- Preuves de crédibilité`,
    },
    webPageQuickFillFaqLabel: {
      en: 'FAQ page',
      fr: 'Page FAQ',
    },
    webPageQuickFillFaqValue: {
      en: `- Main FAQ topic
- Questions to include (list)
- Common customer objections
- Constraints to clarify (pricing, timeline, compatibility…)`,
      fr: `- Sujet principal de la FAQ
- Questions à inclure (liste)
- Objections clients fréquentes
- Contraintes à clarifier (prix, délais, compatibilité…)`,
    },
    contentDirectionOptionnal: {
      en: 'Guidelines & knowledge <span className="font-body-2-r text-branding-gray"> (optional)</span>',
      fr: 'Instructions et expertise <span className="font-body-2-r text-branding-gray"> (optionnel)</span>',
    },
    uploadFailed: {
      en: 'Upload failed',
      fr: 'Échec du téléchargement',
    },
    uploadFailedDescription: {
      en: 'Failed to upload the file. Please try again.',
      fr: 'Échec du téléchargement du fichier. Veuillez réessayer.',
    },
    invalidFileFormat: {
      en: 'Invalid file format',
      fr: 'Format de fichier invalide',
    },
    invalidFileFormatDescription: {
      en: 'Only images (PNG, JPG, GIF, WebP), PDF and CSV files are allowed.',
      fr: 'Seuls les images (PNG, JPG, GIF, WebP), les fichiers PDF et CSV sont autorisés.',
    },
    fileTooLarge: {
      en: 'File too large',
      fr: 'Fichier trop volumineux',
    },
    fileTooLargeDescription: {
      en: 'File size must be less than {{maxSize}}MB.',
      fr: 'La taille du fichier doit être inférieure à {{maxSize}}Mo.',
    },
    advancedSettings: {
      en: 'Advanced settings',
      fr: 'Paramètres avancés',
    },
    outlineStructureSwitch: {
      en: 'Outline structure',
      fr: 'Structure du plan',
    },
  },
  'app.funnel-supporting-material': {
    supportingMaterialWebPageIntro: {
      en: 'For best results, add a screenshot of your wireframe, mockup, or existing page.',
      fr: "Pour de meilleurs résultats, ajoutez une capture d'écran de votre wireframe, maquette ou page existante.",
    },
    supportingMaterialWebPageFormats: {
      en: 'Accepted formats: PDF, JPG, PNG, URLs ({{maxSize}}MB max per file)',
      fr: 'Formats acceptés : PDF, JPG, PNG, URLs ({{maxSize}}MB max par fichier)',
    },
    supportingMaterialWebPageHelpHeading: {
      en: 'This will help:',
      fr: 'Pour vous aider :',
    },
    supportingMaterialWebPageHelpBullet1: {
      en: 'Understand your page structure and sections',
      fr: 'Comprendre la structure et les sections de votre page',
    },
    supportingMaterialWebPageHelpBullet2: {
      en: 'Match content length to your design fields',
      fr: 'Adapter la longueur du contenu à vos champs',
    },
    supportingMaterialWebPageHelpBullet3: {
      en: 'Generate text proportionate to your layout',
      fr: 'Générer du texte proportionné à votre design',
    },
    supportingMaterialWebPageFooter: {
      en: '<b>Tip:</b> Annotate your image to indicate specific areas and their goals (SEO, conversion, branding, etc.).',
      fr: '<b>Conseil:</b> Annotez votre image pour indiquer les zones spécifiques et leurs objectifs (SEO, conversion, branding, etc.).',
    },
    supportingMaterial: {
      en: 'Supporting materials',
      fr: 'Documents supplémentaires',
    },
    supportingMaterialDescription: {
      en: 'Add studies, articles, data, social posts, or other sources to support your content.<br />Accepted formats: PDF, JPG, PNG, URLs ({{maxSize}}MB max per file)',
      fr: `Ajoutez des études, articles, données, posts sur les réseaux sociaux ou d'autres sources pour enrichir votre contenu.<br />Formats acceptés : PDF, JPG, PNG, URLs ({{maxSize}}MB max par fichier)`,
    },
    optional: {
      en: '(optional)',
      fr: '(optionnel)',
    },
    uploadFile: {
      en: 'Upload file',
      fr: 'Télécharger un fichier',
    },
    addURL: {
      en: 'Add URL',
      fr: 'Ajouter une URL',
    },
    addFile: {
      en: 'Add file',
      fr: 'Ajouter un fichier',
    },
    fileURL: {
      en: 'File URL',
      fr: 'URL du fichier',
    },
    whatShouldTheAILearnFromThis: {
      en: 'What should the AI learn from this?',
      fr: "Que doit apprendre l'IA de ce fichier ?",
    },
    whatShouldTheAILearnFromThisPlaceholder: {
      en: 'Tell the AI what to focus on from this file to personalize your content',
      fr: "Dites à l'IA ce que vous voulez qu'elle fasse attention à partir de ce fichier pour personnaliser votre contenu",
    },
  },
  'app.funnel-screenshot-nudge': {
    title: {
      en: 'Add a page screenshot for better results',
      fr: "Ajoutez une capture d'écran de la page pour de meilleurs résultats",
    },
    description: {
      en: 'Upload a screenshot of your website so Blym can understand your layout, structure, and content areas.',
      fr: 'Téléversez une capture de votre site pour que Blym comprenne la mise en page, la structure et les zones de contenu.',
    },
    primaryButton: {
      en: 'Go back and add screenshot',
      fr: 'Retour pour ajouter une capture',
    },
    secondaryButton: {
      en: 'Continue without screenshot',
      fr: "Continuer sans capture d'écran",
    },
  },
  'app.funnel-funnelToolbar': {
    geo: {
      en: 'GEO',
      fr: 'GEO',
    },
    whatLLMareSaying: {
      en: 'What the LLM are saying',
      fr: 'Ce que les IA disent',
    },
    sources: {
      en: 'Sources ({{count}})',
      fr: 'Sources ({{count}})',
    },
    noSourcesAvailable: {
      en: 'No sources available',
      fr: 'Aucune source disponible',
    },
    noLLMTextAvailable: {
      en: 'No result available',
      fr: 'Aucun résultat disponible',
    },
    whatIsGEO: {
      en: 'What is GEO?',
      fr: "Qu'est-ce que GEO ?",
    },
    whatIsGEODescription: {
      en: 'GEO is the practice of optimizing content so it is discovered, understood, and cited by AI systems like ChatGPT, Gemini, Perplexity, Claude, etc.',
      fr: "GEO est la pratique d'optimisation de contenu pour qu'il soit découvert, compris et cité par des systèmes d'IA comme ChatGPT, Gemini, Perplexity, Claude, etc.",
    },
    noGEOFound: {
      en: "Currently this content doesn't have any GEO information. Please create a new one to access it",
      fr: "Actuellement, ce contenu n'a pas d'informations GEO. Veuillez en créer une nouvelle pour y accéder",
    },
    contentGaps: {
      en: 'Content gaps',
      fr: 'Opportunités de sujets',
    },
    contentGapsDescription: {
      en: 'What LLMs are saying that isn’t included in your content',
      fr: 'Contenu manquant indiqué/repéré par les IA. (example)',
    },
    responsePreview: {
      en: 'Response preview',
      fr: 'Aperçu de la réponse',
    },
    llmResponses: {
      en: 'LLM responses',
      fr: 'Réponses des IA',
    },
    keyMetrics: {
      en: 'Key metrics',
      fr: 'Métriques clés',
    },
    readfullResponse: {
      en: 'Read full response →',
      fr: 'Lire en entier →',
    },
    writeWithAI: {
      en: 'Generate with AI',
      fr: 'Générer avec IA',
    },
    generateOutline: {
      en: 'Generate outline',
      fr: 'Générer le plan',
    },
    goToOutlines: {
      en: 'Save and go to outlines',
      fr: 'Générer le plan',
    },
    title: {
      en: 'Title',
      fr: 'Titre',
    },
    outlines: {
      en: 'Outline',
      fr: 'Plan',
    },
    contentBrief: {
      en: 'Content brief',
      fr: 'Brief de contenu',
    },
    generateTitles: {
      en: 'Generate titles',
      fr: 'Générer les titres',
    },
    goToTitles: {
      en: 'Save and go to titles',
      fr: 'Générer les titres',
    },
    generateContent: {
      en: 'Generate content',
      fr: 'Générer le contenu',
    },
    SEOOverview: {
      en: 'SEO Overview',
      fr: 'Aperçu SEO',
    },
    keyInsights: {
      en: 'Key insights to guide your content decisions',
      fr: 'Insights clés pour guider vos décisions de contenu',
    },
    searchInsights: {
      en: 'Search insights™',
      fr: 'Search insights™',
    },
  },
  'app.content.dialogFunnelFirstStep': {
    title: {
      en: 'How do you want to write your content?',
      fr: 'Comment voulez-vous écrire votre contenu ?',
    },
    description: {
      en: 'Write manually with AI assistance or let AI generate outlines, headings, and paragraphs for you.',
      fr: "Écrivez manuellement avec l'assistance de l'IA ou laissez l'IA générer des plans, des titres et des paragraphes pour vous.",
    },
    fromScratch: {
      en: 'Start from scratch',
      fr: 'Commencer de zéro',
    },
    startWithAi: {
      en: 'Start with AI',
      fr: 'Commencer avec IA',
    },
    somethingWentWrong: {
      en: 'Something went wrong, please try again later',
      fr: "Quelque chose s'est mal passé, veuillez réessayer plus tard",
    },
  },
  'app.funnel-outlines': {
    generateOutline: {
      en: 'Generate outline',
      fr: 'Générer le plan',
    },
    thisMightTakeAWhile: {
      en: 'This might take a few minutes, you can leave the page and come back later.',
      fr: 'Cela peut prendre quelques minutes, vous pouvez quitter la page et revenir plus tard.',
    },
    outlinesTitle: {
      en: 'Fine-tune your content outline.',
      fr: 'Affinez votre plan.',
    },
    outlinesSubTitle: {
      en: 'Adding specific instructions here dramatically improves output quality. ',
      fr: 'Ajouter des instructions spécifiques ici améliore considérablement la qualité de la sortie.',
    },
    outlinesSubTitleDescription: {
      en: 'Include your expertise, examples, data points, or unique angles for each key section.',
      fr: 'Incluez votre expertise, vos exemples, vos points de données ou vos angles uniques pour chaque section clé.',
    },
    outlinesTooShort: {
      en: 'Outlines are too short, please add more headings.',
      fr: 'Les plans sont trop courts, veuillez ajouter plus de titres.',
    },
    refreshOutlines: {
      en: 'Refresh outline',
      fr: 'Recharger le plan',
    },
    seeInstructions: {
      en: 'See instructions',
      fr: 'Voir les instructions',
    },
    wordCount: {
      en: 'Estimated words count',
      fr: 'Nombre de mots estimé',
    },
    noContentFunnelFound: {
      en: 'No content funnel found',
      fr: 'Aucun contenu de funneling trouvé',
    },
    settingsTitle: {
      en: 'Define the voice of your content',
      fr: 'Définissez la voix de votre contenu',
    },
    useBrandContext: {
      en: 'Use brand context',
      fr: 'Utiliser le brand context',
    },
    extraInformation: {
      en: 'Extra information (optional)',
      fr: 'Informations supplémentaires',
    },
    extraInformationPlaceholder: {
      en: 'E.g: You are a doctor that is writing to speak about a specific pill.',
      fr: "E.g: Vous êtes un médecin qui écrit pour parler d'une pilule spécifique.",
    },
    extraInformationDescription: {
      en: 'Tell anything you might need to the AI to reach the result you are looking for.',
      fr: "Dites tout ce que vous pourriez avoir besoin de l'IA pour atteindre le résultat que vous recherchez.",
    },
    modalTitle: {
      en: 'Your generated content will be too short.',
      fr: 'Votre contenu généré sera trop court.',
    },
    modalDescription: {
      en: 'You need to add more headings to reach the content length required by Google for this topic. We recommend you to update your outline before continuing.',
      fr: 'Vous devez ajouter plus de titres pour atteindre la longueur de contenu requise par Google pour ce sujet. Nous vous recommandons de mettre à jour votre plan avant de continuer.',
    },
    addMoreHeadings: {
      en: 'Add more headings',
      fr: 'Ajouter plus de titres',
    },
    continueAnyway: {
      en: 'Continue anyway',
      fr: 'Continuer quand même',
    },
  },

  'app.funnel-outlines-editor': {
    addHeadingAbove: {
      en: 'Add heading above',
      fr: 'Ajouter un en-tête au-dessus',
    },
    addHeadingBelow: {
      en: 'Add heading below',
      fr: 'Ajouter un en-tête en dessous',
    },
    deleteHeading: {
      en: 'Delete heading',
      fr: 'Supprimer un en-tête',
    },
    addHeading: {
      en: 'Add heading',
      fr: 'Ajouter un titre',
    },
    failedToAddHeading: {
      en: 'Failed to add heading',
      fr: "Erreur lors de l'ajout d'un en-tête",
    },
    instructionsPlaceholder: {
      en: '+ Add guidance to help the AI generate better content.',
      fr: `+ Ajoutez des instructions pour aider l'IA à générer un meilleur contenu.`,
    },
  },
  'app.funnel-content': {
    generatingContent: {
      en: 'Generating content...',
      fr: 'Génération de contenu...',
    },
    thisMightTakeAWhile: {
      en: 'This might take a few minutes, you can leave the page and come back later.',
      fr: 'Cela peut prendre quelques minutes, vous pouvez quitter la page et revenir plus tard.',
    },
    noContentFunnelFound: {
      en: 'No content funnel found',
      fr: 'Aucun contenu de funneling trouvé',
    },
  },
  'app.errorScreen': {
    error: {
      en: 'An unexpected error occurred.',
      fr: 'Une erreur inattendue est survenue.',
    },
    errorDescription: {
      en: 'Please contact our support team so we can resolve this quickly.',
      fr: 'Veuillez contacter notre équipe de support pour que nous puissions résoudre ce problème rapidement.',
    },
  },
  'app.content.upsell': {
    title: {
      en: 'Generate on-brand <br> <span className="text-gradient-accent font-display-2">content pages at scale</span>',
      fr: 'Générer des pages <br> de contenu<span className="text-gradient-accent font-display-2"> à grande échelle</span>',
    },
    description1: {
      en: '<span className="text-branding-accent-800 font-body-2-sb">Create detailled content pages in minutes</span> with fast, bulk generation.',
      fr: '<span className="text-branding-accent-800 font-body-2-sb">Créez des pages de contenu détaillées en quelques minutes</span> avec la création de contenu alimentée par l’IA.',
    },
    description2: {
      en: '<span className="text-branding-accent-800 font-body-2-sb">Update existing content pages automatically</span> following your site’s template and SEO structure.',
      fr: '<span className="text-branding-accent-800 font-body-2-sb">Mettez à jour les pages de contenu existantes automatiquement</span> en suivant la structure de votre site et le modèle SEO.',
    },
    description3: {
      en: '<span className="text-branding-accent-800 font-body-2-sb">Stay perfectly on-brand</span>, as Blym reproduces your unique tone of voice and way of addressing your customers.',
      fr: '<span className="text-branding-accent-800 font-body-2-sb">Restez parfaitement sur-mesure</span>, car Blym reproduit votre ton unique et votre façon de parler à vos clients.',
    },
    requestDemo: {
      en: 'Request a demo',
      fr: 'Demander une démo',
    },
  },
  'app.seo-strategy': {
    pageTitle: {
      en: 'SEO strategy',
      fr: 'Audit SEO',
    },
    heroTitle: {
      en: 'Know exactly what to write to win on search',
      fr: 'Ciblez les bons mots-clés et attirez plus de trafic qualifié.',
    },
    heroSubtitle: {
      en: "We'll analyze your website, competitors, and industry to build a comprehensive keyword audit and a tailored 3-month action plan to grow your organic traffic.",
      fr: "Nous analysons votre site, vos concurrents et votre secteur pour identifier les meilleures opportunités de positionnement, et vous donner un plan d'action clair sur 3 mois.",
    },
    heroCta: {
      en: 'Set up your SEO strategy',
      fr: 'Démarrer mon audit SEO',
    },
    heroCalloutWatch: {
      en: 'Watch how the SEO Audit works',
      fr: "Regardez comment fonctionne l'audit SEO",
    },
    refreshAudit: {
      en: 'Regenerate audit',
      fr: "Régénérer l'audit",
    },
    refreshModalTitle: {
      en: 'Regenerate audit?',
      fr: "Régénérer l'audit ?",
    },
    refreshModalBody: {
      en: 'This action will replace all existing recommendations. This action cannot be undone.',
      fr: "Cette action remplacera l'ensemble des recommandations existantes. Cette action est irréversible.",
    },
    refreshModalConfirm: {
      en: 'Refresh audit ({{creditCost}} credit)',
      fr: "Actualiser l'audit ({{creditCost}} crédit)",
    },
    refreshModalCancel: {
      en: 'Cancel',
      fr: 'Annuler',
    },
    refreshAuditModalTitle: {
      en: 'Refresh audit',
      fr: "Actualiser l'audit",
    },
    refreshAuditModalSubtitle: {
      en: "We'll re-run with the info below. Update anything that's changed.",
      fr: 'Nous relancerons avec les informations ci-dessous. Mettez à jour ce qui a changé.',
    },
    refreshAuditSeoContext: {
      en: 'SEO context',
      fr: 'Contexte SEO',
    },
    refreshAuditTargetMarket: {
      en: 'Target market',
      fr: 'Marché cible',
    },
    refreshAuditWebsite: {
      en: 'Website',
      fr: 'Site web',
    },
    refreshAuditCompetitors: {
      en: 'Competitors',
      fr: 'Concurrents',
    },
    refreshAuditBusinessInfo: {
      en: 'Business information',
      fr: 'Informations entreprise',
    },
    refreshAuditProductsServices: {
      en: 'Products & services',
      fr: 'Produits & services',
    },
    refreshAuditPainPoints: {
      en: 'Customer pain points',
      fr: 'Points de douleur clients',
    },
    refreshAuditContentStrategy: {
      en: 'Content strategy',
      fr: 'Stratégie de contenu',
    },
    refreshAuditPublishingPace: {
      en: 'Publishing pace',
      fr: 'Cadence de publication',
    },
    refreshAuditPagesPerMonthValue: {
      en: '{{count}} pages / month',
      fr: '{{count}} pages / mois',
    },
    dashboardSubtitle: {
      en: 'Build a data driven plan to grow your organic traffic',
      fr: 'Construisez un plan basé sur les données pour développer votre trafic organique',
    },
    tabOverview: {
      en: 'Overview',
      fr: "Vue d'ensemble",
    },
    comingSoon: {
      en: 'Coming soon',
      fr: 'À venir',
    },
    tabActionPlan: {
      en: 'Action Plan',
      fr: "Plan d'action",
    },
    tabKeywords: {
      en: 'Keywords Opportunities',
      fr: 'Opportunités de mots-clés',
    },
  },
  'app.seo-strategy-setup-seo-modal': {
    title: {
      en: 'Set up your SEO strategy',
      fr: "Configuration de l'audit",
    },
    fieldRequired: {
      en: 'Field required',
      fr: 'Champ requis',
    },
    optional: {
      en: '(Optional)',
      fr: '(Facultatif)',
    },
    stepOf: {
      en: '<0>Step {{current}}</0> of {{total}}',
      fr: '<0>Étape {{current}}</0> sur {{total}}',
    },
    back: {
      en: 'Back',
      fr: 'Retour',
    },
    next: {
      en: 'Next',
      fr: 'Suivant',
    },
    submit: {
      en: 'Generate my SEO strategy',
      fr: 'Générer ma stratégie SEO',
    },
    startAudit: {
      en: 'Start audit ({{ creditCost }} credit)',
      fr: "Lancer l'audit ({{ creditCost }} crédit)",
    },
    step1Title: {
      en: 'Define your SEO context',
      fr: 'Définissez votre contexte SEO',
    },
    targetCountry: {
      en: 'Target Country',
      fr: 'Pays cible',
    },
    language: {
      en: 'Language',
      fr: 'Langue',
    },
    websiteUrl: {
      en: 'Website URL',
      fr: 'URL du site web',
    },
    websiteUrlPlaceholder: {
      en: 'https://example.com',
      fr: 'https://example.com',
    },
    competitors: {
      en: 'Competitors <0>(up to 3)</0>',
      fr: "Concurrents <0>(jusqu'à 3)</0>",
    },
    competitorPlaceholder: {
      en: 'https://example.com',
      fr: 'https://example.com',
    },
    addCompetitor: {
      en: 'Add competitor',
      fr: 'Ajouter un concurrent',
    },
    step2Products: {
      en: 'What are the primary products and services that you offer?',
      fr: 'Quels sont les principaux produits et services que vous proposez ?',
    },
    step2ProductsOptionnal: {
      en: 'What are the primary products and services that you offer? <span className="text-branding-gray">(Optional)</span>',
      fr: 'Quels sont les principaux produits et services que vous proposez ? <span className="text-branding-gray">(Facultatif)</span>',
    },
    step2ProductsPlaceholder: {
      en: 'Describe your main products, services, and value proposition...',
      fr: 'Décrivez vos principaux produits, services et proposition de valeur...',
    },
    step2PainPoints: {
      en: 'What specific problems or pain points do you solve for your customers?',
      fr: 'Quels problèmes spécifiques ou points douloureux résolvez-vous pour vos clients ?',
    },
    step2PainPointsOptionnal: {
      en: 'What specific problems or pain points do you solve for your customers? <span className="text-branding-gray">(Optional)</span>',
      fr: 'Quels problèmes spécifiques ou points douloureux résolvez-vous pour vos clients ? <span className="text-branding-gray">(Facultatif)</span>',
    },
    step2PainPointsPlaceholder: {
      en: 'List the key challenges your customers face that you help to resolve...',
      fr: 'Listez les principaux défis auxquels vos clients font face et que vous aidez à résoudre...',
    },
    step3SalesQuestions: {
      en: 'What are the most frequent questions you receive during sales calls or prior to a purchase?',
      fr: 'Quelles sont les questions les plus fréquentes que vous recevez lors des appels de vente ou avant un achat ?',
    },
    step3SalesQuestionsOptionnal: {
      en: 'What are the most frequent questions you receive during sales calls or prior to a purchase? <span className="text-branding-gray">(Optional)</span>',
      fr: 'Quelles sont les questions les plus fréquentes que vous recevez lors des appels de vente ou avant un achat ? <span className="text-branding-gray">(Facultatif)</span>',
    },
    step3SalesQuestionsPlaceholder: {
      en: 'Share the recurring questions prospects ask before buying...',
      fr: "Partagez les questions récurrentes que les prospects posent avant d'acheter...",
    },
    step3Barriers: {
      en: 'What are the main barriers or objections that prevent your customers from buying?',
      fr: "Quels freins empêchent vos prospects de passer à l'achat ?",
    },
    step3BarriersOptionnal: {
      en: 'What are the main barriers or objections that prevent your customers from buying? <span className="text-branding-gray">(Optional)</span>',
      fr: 'Quels freins empêchent vos prospects de passer à l\'achat ? <span className="text-branding-gray">(Facultatif)</span>',
    },
    step3BarriersPlaceholder: {
      en: 'Describe the common reasons prospects hesitate or decide not to purchase...',
      fr: 'Décrivez les raisons courantes pour lesquelles les prospects hésitent ou décident de ne pas acheter...',
    },
    step4AdditionalInfo: {
      en: 'Is there any additional information specific to your business that you would like to add?',
      fr: 'Y a-t-il des informations supplémentaires spécifiques à votre entreprise que vous souhaitez ajouter ?',
    },
    step4AdditionalInfoOptionnal: {
      en: 'Is there any additional information specific to your business that you would like to add? <span className="text-branding-gray">(Optional)</span>',
      fr: 'Y a-t-il des informations supplémentaires spécifiques à votre entreprise que vous souhaitez ajouter ? <span className="text-branding-gray">(Facultatif)</span>',
    },
    step4AdditionalInfoPlaceholder: {
      en: 'Share the recurring questions prospects ask before buying...',
      fr: 'Partagez toute information supplémentaire pertinente pour votre stratégie SEO...',
    },
    step5Title: {
      en: 'How many pages do you want to publish per month?',
      fr: 'Combien de pages souhaitez-vous publier par mois ?',
    },
    step5Subtitle: {
      en: "Based on your audit results, we'll build a tailored action plan with the right mix of new content and refreshes. You can always adjust this later.",
      fr: "En fonction de vos résultats d'audit, nous construirons un plan d'action adapté avec le bon mélange de nouveau contenu et de rafraîchissements. Vous pourrez toujours l'ajuster plus tard.",
    },
    pagesPerMonth: {
      en: '<span className="font-body-2-sb">pages</span> /month',
      fr: '<span className="font-body-2-sb">pages</span> /mois',
    },
    lightPace: {
      en: 'Light pace',
      fr: 'Rythme léger',
    },
    moderatePace: {
      en: 'Moderate pace',
      fr: 'Rythme modéré',
    },
    recommended: {
      en: 'Recommended',
      fr: 'Recommandé',
    },
    intensive: {
      en: 'Intensive',
      fr: 'Intensif',
    },
    maximumOutput: {
      en: 'Maximum output',
      fr: 'Production maximale',
    },
  },
  'app.seo-strategy-loading': {
    title: {
      en: 'Setting up your SEO strategy...',
      fr: 'Configuration de votre stratégie SEO...',
    },
    subtitle: {
      en: 'This may take up to',
      fr: "Cela peut prendre jusqu'à",
    },
    subtitleBold: {
      en: '3 minutes.',
      fr: '3 minutes.',
    },
    goToDashboard: {
      en: 'Go to Dashboard',
      fr: 'Aller au tableau de bord',
    },
    notification: {
      en: 'You will be notified once it is ready',
      fr: "Vous serez notifié une fois que c'est prêt",
    },
    loading1Title: {
      en: 'Analyzing your site…',
      fr: 'Analyse de votre site…',
    },
    loading1Description: {
      en: 'This may take up to 2 minutes.',
      fr: "Cela peut prendre jusqu'à 2 minutes.",
    },
    loading2Title: {
      en: 'Building your plan…',
      fr: 'Construction de votre plan…',
    },
    loading2Description: {
      en: 'Mapping your best keywords',
      fr: 'Identification de vos meilleurs mots-clés',
    },
    loading3Title: {
      en: 'Scoring your opportunities…',
      fr: 'Évaluation de vos opportunités…',
    },
    loading3Description: {
      en: 'Ranking every keyword by impact potential',
      fr: "Classement de chaque mot-clé par potentiel d'impact",
    },
    card1Title: {
      en: '💡 Did you know? The top 3 Google results capture <span>55% of all clicks</span>. Your ranking position matters a lot.',
      fr: '💡 Le saviez-vous ? Les 3 premiers résultats Google captent <span>55 % de tous les clics</span>. Votre position compte énormément.',
    },
    card2Title: {
      en: '💡 Good to know — A page title between <span>50–60 characters</span> gets a higher click-through rate in search results.',
      fr: '💡 Bon à savoir — Un titre de page entre <span>50 et 60 caractères</span> obtient un meilleur taux de clics dans les résultats de recherche.',
    },
    card3Title: {
      en: '💡 Pro tip — A keyword with a <span>high opportunity score</span> means low competition and real search volume, exactly where to strike first.',
      fr: "💡 Conseil — Un mot-clé avec un <span>score d'opportunité élevé</span> signifie faible concurrence et vrai volume de recherche, exactement là où frapper en premier.",
    },
  },
  'app.seo-strategy-overview': {
    bofuDesc: {
      en: 'Ready to buy (BOFU)',
      fr: 'Prêt à acheter (BOFU)',
    },
    mofuDesc: {
      en: 'Comparing options (MOFU)',
      fr: 'En phase de comparaison (MOFU)',
    },
    tofuDesc: {
      en: 'Discovering solutions (TOFU)',
      fr: 'En phase de découverte (TOFU)',
    },
    totalKeywords: {
      en: 'Identified keyword opportunities',
      fr: 'Opportunités de mots-clés identifiés',
    },
    monthlySearchVolume: {
      en: 'Estimated monthly visitor potential',
      fr: 'Potentiel de visiteurs mensuels sur ces mots-clés',
    },
    currentlyRanking: {
      en: 'Keywords you already rank for',
      fr: 'Mots-clés qui rank',
    },
    notRanking: {
      en: 'Keywords left to win',
      fr: 'Mots-clés à conquérir',
    },
    growthPotential: {
      en: '{{percent}}% - Growth potential',
      fr: '{{percent}}% de trafic supplémentaire à aller chercher',
    },
    currentRankingDistribution: {
      en: 'Current Google Ranking Distribution',
      fr: 'Vos positions actuelles sur Google',
    },
    searchVolumeByConversionProbability: {
      en: 'Keywords by purchase intent',
      fr: "Mots-clés par intention d'achat",
    },
    top3: { en: 'Top 3', fr: 'Top 3' },
    top10: { en: 'Top 10', fr: 'Top 10' },
    top30: { en: 'Top 30', fr: 'Top 30' },
    beyond30: { en: 'Beyond 30', fr: 'Au-delà de 30' },
    notRankingLabel: { en: 'Not ranking', fr: 'Non classé' },
    volumeDescription: {
      en: '{{percent}}% of total volume — {{count}} keyword',
      fr: '{{percent}}% du volume total — {{count}} mot-clé',
    },
    volumeDescriptionPlural: {
      en: '{{percent}}% of total volume — {{count}} keywords',
      fr: '{{percent}}% du volume total — {{count}} mots-clés',
    },
    high: { en: 'High', fr: 'Élevé' },
    medium: { en: 'Medium', fr: 'Moyen' },
    low: { en: 'Low', fr: 'Faible' },
    bottomOfFunnel: { en: 'Bottom of funnel', fr: 'Bas du funnel' },
    middleOfFunnel: { en: 'Middle of funnel', fr: 'Milieu du funnel' },
    keywords: { en: 'keywords', fr: 'mots-clés' },
    strategicAnalysis: {
      en: 'Strategic analysis',
      fr: 'Analyse stratégique',
    },
    strengths: { en: 'Strengths', fr: 'Forces' },
    opportunities: { en: 'Opportunities', fr: 'Opportunités' },
    weaknesses: { en: 'Weaknesses', fr: 'Faiblesses' },
  },
  'app.seo-strategy-action-plan': {
    title: {
      en: 'Action Plan',
      fr: "Plan d'action",
    },
    subtitleFull: {
      en: 'Follow this plan to maximize your SEO growth and <bold>generate up to {{traffic}} visits and {{leads}} new leads per month.</bold> Refresh the audit to generate a new plan.',
      fr: "Suivez ce plan pour maximiser votre croissance SEO et <bold>générez jusqu'à {{traffic}} visites et {{leads}} nouveaux prospects par mois.</bold> Actualisez l'audit pour générer un nouveau plan.",
    },
    addAction: {
      en: 'Add Action',
      fr: 'Ajouter une action',
    },
    highImpact: {
      en: 'High impact',
      fr: 'Impact élevé',
    },
    priorityTasks: {
      en: 'priority tasks',
      fr: 'tâches prioritaires',
    },
    estimatedTraffic: {
      en: 'Estimated traffic',
      fr: 'Trafic estimé',
    },
    visitors: {
      en: 'visitors',
      fr: 'visiteurs',
    },
    estimatedLeads: {
      en: 'Estimated leads',
      fr: 'Prospects estimés',
    },
    conversions: {
      en: 'conversions',
      fr: 'conversions',
    },
    overallProgress: {
      en: 'Overall progress',
      fr: 'Progression générale',
    },
    estimatedTime: {
      en: 'Estimated Time: ~{{time}} remaining / {{done}} of {{total}} tasks completed',
      fr: 'Temps estimé : ~{{time}} restant / {{done}} sur {{total}} tâches complétées',
    },
    week: {
      en: 'Week {{number}}',
      fr: 'Semaine {{number}}',
    },
    refresh: {
      en: 'Refresh',
      fr: 'Actualiser',
    },
    create: {
      en: 'Create',
      fr: 'Créer',
    },
    minTask: {
      en: '{{min}} min task',
      fr: 'Tâche de {{min}} min',
    },
    traffic: {
      en: 'traffic',
      fr: 'trafic',
    },
    leads: {
      en: 'leads',
      fr: 'prospects',
    },
    taskTitleRefresh: {
      en: 'Refresh existing content for "{{keyword}}"',
      fr: 'Actualiser le contenu existant pour "{{keyword}}"',
    },
    taskTitleCreate: {
      en: 'Write and publish an article about "{{keyword}}"',
      fr: 'Rédiger et publier un article sur "{{keyword}}"',
    },
    cycleFooter: {
      en: 'This plan is designed for a 3-month cycle.',
      fr: 'Ce plan est conçu pour un cycle de 3 mois.',
    },
    cycleFooterDescription: {
      en: 'Once all three months are completed, we recommend refreshing your audit to generate an updated plan based on your new rankings and content performance.',
      fr: "Une fois les trois mois terminés, nous vous recommandons d'actualiser votre audit pour générer un plan mis à jour basé sur vos nouveaux classements et performances de contenu.",
    },
  },
  'app.seo-strategy-keywords': {
    searchPlaceholder: {
      en: 'Search keywords',
      fr: 'Rechercher des mots-clés',
    },
    keywordLinked: {
      en: 'Keyword successfully linked to content',
      fr: 'Mot-clé lié au contenu avec succès',
    },
    noUrlForRefresh: {
      en: 'This keyword has no URL to refresh',
      fr: "Ce mot-clé n'a pas d'URL à actualiser",
    },
    allLevels: {
      en: 'All Levels',
      fr: 'Tous les niveaux',
    },
    allDifficulties: {
      en: 'All Difficulties',
      fr: 'Toutes les difficultés',
    },
    allPositions: {
      en: 'All Positions',
      fr: 'Toutes les positions',
    },
    addKeywords: {
      en: 'Add keywords',
      fr: 'Ajouter des mots-clés',
    },
    comingSoon: {
      en: 'Coming soon',
      fr: 'À venir',
    },
    colKeyword: {
      en: 'Keyword',
      fr: 'Mot-clé',
    },
    colStatus: {
      en: 'Status',
      fr: 'Statut',
    },
    colScore: {
      en: 'Score',
      fr: 'Score',
    },
    colPosition: {
      en: 'Pos',
      fr: 'Pos',
    },
    colVolume: {
      en: 'Vol',
      fr: 'Vol',
    },
    colDifficulty: {
      en: 'Diff',
      fr: 'Diff',
    },
    colCompetition: {
      en: 'Comp',
      fr: 'Comp',
    },
    colBusiness: {
      en: 'Business',
      fr: 'Business',
    },
    colAction: {
      en: 'Action',
      fr: 'Action',
    },
    colUrl: {
      en: 'URL',
      fr: 'URL',
    },
    colOrigin: {
      en: 'Origin',
      fr: 'Origine',
    },
    totalKeywords: {
      en: '{{count}} keywords',
      fr: '{{count}} mots-clés',
    },
    statusDraft: { en: 'To create', fr: 'À créer' },
    statusInProgress: { en: 'In progress', fr: 'En cours' },
    statusPublished: { en: 'Published', fr: 'Publié' },
    businessHigh: { en: 'High', fr: 'Élevé' },
    businessMedium: { en: 'Medium', fr: 'Moyen' },
    businessLow: { en: 'Low', fr: 'Faible' },
    actionRefresh: { en: 'Refresh', fr: 'Actualiser' },
    actionCreate: { en: 'Create', fr: 'Créer' },
    actionOpen: { en: 'Open', fr: 'Ouvrir' },
    copiedToClipboard: { en: 'Copied to clipboard', fr: 'Copié dans le presse-papiers' },
    originYourPages: { en: 'Your pages', fr: 'Vos pages' },
    originCompetitorAnalysis: { en: 'Competitor analysis', fr: 'Analyse concurrents' },
    originSuggestedByBlym: { en: 'Suggested by Blym', fr: 'Suggéré par Blym' },
    originIdea: { en: 'Idea', fr: 'Suggestion' },
    originCompetition: { en: 'Competition', fr: 'Concurrence' },
    selected: { en: 'selected', fr: 'sélectionnés' },
    removeSelected: { en: 'Remove {{count}}', fr: 'Supprimer {{count}}' },
    addToPlan: { en: 'Add to plan', fr: 'Ajouter au plan' },
    tooltipKeyword: {
      en: 'A search query users type into Google to find content related to your business.',
      fr: 'Une requête de recherche que les utilisateurs tapent sur Google pour trouver du contenu lié à votre activité.',
    },
    tooltipStatus: {
      en: 'Current state of the keyword in your content pipeline: Draft, In Progress, To review, Approved, Published.',
      fr: 'État actuel du mot-clé dans votre pipeline de contenu : Brouillon, En cours, À réviser, Approuvé, Publié.',
    },
    tooltipScore: {
      en: 'A Blym AI score that measures how much this keyword should be prioritized in your SEO/GEO strategy, combining business interest, competition, search volume, and ranking potential.',
      fr: "Un score IA Blym qui mesure dans quelle mesure ce mot-clé doit être priorisé dans votre stratégie SEO/GEO, en combinant l'intérêt commercial, la concurrence, le volume de recherche et le potentiel de classement.",
    },
    tooltipPosition: {
      en: 'Represents the current position of the site on the SERP (Search Engine Results Page).',
      fr: 'Représente la position actuelle du site sur la SERP (page de résultats des moteurs de recherche).',
    },
    tooltipVolume: {
      en: 'Indicates the number of monthly searches for the keyword.',
      fr: 'Indique le nombre de recherches mensuelles pour ce mot-clé.',
    },
    tooltipDifficulty: {
      en: 'Evaluates the keyword difficulty, classified using three colors: green (easy), orange (moderate), and red (hard).',
      fr: 'Évalue la difficulté du mot-clé, classée en trois couleurs : vert (facile), orange (modéré) et rouge (difficile).',
    },
    tooltipCompetition: {
      en: 'Measures the level of competition on the SERP. The higher this indicator, the more competitive the keyword.',
      fr: 'Mesure le niveau de concurrence sur la SERP. Plus cet indicateur est élevé, plus le mot-clé est compétitif.',
    },
    tooltipBusiness: {
      en: 'Indicates how likely a searcher is to convert into a customer. High = ready to buy, Medium = comparing solutions, Low = browsing and learning.',
      fr: "Indique la probabilité qu'un internaute se convertisse en client. Élevé = prêt à acheter, Moyen = compare des solutions, Faible = en phase de découverte.",
    },
    tooltipOrigin: {
      en: "Where did this keyword idea come from? 'Website' means it was found on your existing website. 'Competitor analysis' means it was discovered by analyzing your competitors. 'Suggested by Blym' means it was recommended by our algorithm.",
      fr: "D'où vient cette idée de mot-clé ? 'Site web' signifie qu'il a été trouvé sur votre site existant. 'Analyse concurrents' signifie qu'il a été découvert en analysant vos concurrents. 'Suggéré par Blym' signifie qu'il a été recommandé par notre algorithme.",
    },
    month1: { en: 'Month 1', fr: 'Mois 1' },
    month2: { en: 'Month 2', fr: 'Mois 2' },
    month3: { en: 'Month 3', fr: 'Mois 3' },
    month4: { en: 'Month 4', fr: 'Mois 4' },
    month5: { en: 'Month 5', fr: 'Mois 5' },
    month6: { en: 'Month 6', fr: 'Mois 6' },
  },
  'mobile-blocker': {
    title: {
      en: '<span className="font-display-1 italic text-branding-accent-900">We’re sorry</span> but this part of the app is not available on mobile yet',
      fr: '<span className="font-display-1 italic text-branding-accent-900">Nous sommes désolés</span> mais cette partie de l\'application n\'est pas encore disponible sur mobile',
    },
    description: {
      en: 'Please view on a laptop or desktop',
      fr: "Merci d'ouvrir l'app sur un ordinateur",
    },
  },
};
